import { useState, useContext, useEffect, useRef } from 'react';
import Context, { AccessContext } from '../components/context.js';
import SpeakerCard from '../components/speaker-card.js';
import EventCard from '../components/event-card.js';
import MerchCard from '../components/merch-card.js';
import SponsorCard from '../components/sponsor-card.js';
import VideoCard from '../components/video-card.js';
import ImageCard from '../components/image-card.js';
import LinkCard from '../components/link-card.js';
import AudioPlayer from '../components/AudioPlayer.js';
import DragDrop from '../components/drag-drop-file.js';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import appleSvg from '../images/apple.svg';
import audibleSvg from '../images/audible.svg';
import castboxSvg from '../images/castbox.svg';
import iheartradioSvg from '../images/iheartradio.svg';
import pandoraSvg from '../images/pandora.svg';
import podbeanSvg from '../images/podbean.svg';
import wonderySvg from '../images/wondery.svg';
import youtubemusicSvg from '../images/youtubemusic.svg';
import placeholderImage from '../images/placeholder.webp';
import Expandable from '../components/expandable.js';
import { faEnvelope, faImage } from '@fortawesome/free-regular-svg-icons';
import { faGlobe, faXmark, faPlus, faChevronDown, faDownload } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faXTwitter, faInstagram, faTiktok, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import Dialog from '../components/dialog.jsx';
import { AppSpeakerCard, AppEventCard } from '../components/app-cards.jsx';
import { SortableContainer } from '../components/sortable.jsx';
import YouTube from 'react-youtube';
import FileDragDrop from '../components/drag-drop.jsx';
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import RTE from '../components/rte.jsx';

const YouTubeShort = ({ videoId }) => {
  const opts = {
    height: '560',
    width: '315',
    playerVars: {
      autoplay: 0,
    },
  };

  return <YouTube videoId={videoId} opts={opts} />;
};
const ModulePosition = ({ position, setPositions, index }) => {
    const buttonContainer = useRef(null);
    const [_itemPosition, setItemPosition] = useState(1);
    const [_count, setCount] = useState(2);
    const moRef = useRef(null);
    useEffect(() => {
        /*const [itemPosition, count] = getPositions();
        setItemPosition(itemPosition);
        setCount(count);
        setPositions(_p => {
            let p = [..._p];
            p[index] = itemPosition + 1;
            return p;
        });
        const onPositionsChanged = () => {
            requestAnimationFrame(recomputeFromDOM);
        };

        window.addEventListener('modules:positionsChanged', onPositionsChanged);

        const container = buttonContainer.current?.closest('.app-preview');
        if (container) {
            moRef.current = new MutationObserver(() => {
                requestAnimationFrame(recomputeFromDOM);
            });
            moRef.current.observe(container, { childList: true, subtree: false });
        }

        return () => {
            window.removeEventListener('modules:positionsChanged', onPositionsChanged);
            if (moRef.current) moRef.current.disconnect();
        };*/
    }, []);

    const dispatchPositionsChanged = () => {
        requestAnimationFrame(() => {
            window.dispatchEvent(new CustomEvent('modules:positionsChanged'));
        });
    };

    const getPositions = (e) => {
        const target = e?.target || buttonContainer.current;
        if (!target)
            return [null, null];
        const container = target.closest('.app-preview');
        const item = target.closest('.sortable-item');
        const items = container.querySelectorAll('.sortable-item');
        const itemPosition = Array.from(items).sort((a, b) => parseInt(a.style.order) - parseInt(b.style.order)).findIndex(i => i == item);
        return [itemPosition, items.length];
    }
    const recomputeFromDOM = () => {
        const [itemPosition, count] = getPositions();
        if (itemPosition !== null && itemPosition !== undefined) setItemPosition(itemPosition);
        if (count !== null && count !== undefined) setCount(count);
    };
    const inc = (e) => {
        const [itemPosition, count] = getPositions(e);
        if (itemPosition == count - 1)
            return;
        setPositions(_p => {
            let p = [..._p];
            let i = p.findIndex(a => a === itemPosition + 2);
            p[i]--;
            p[index] = itemPosition + 2;
            return p;
        });
        
        requestAnimationFrame(recomputeFromDOM);
        dispatchPositionsChanged();
    }
    const dec = (e) => {
        const [itemPosition, count] = getPositions(e);
        if (itemPosition == 0)
            return;
        setPositions(_p => {
            let p = [..._p];
            let i = p.findIndex(a => a === itemPosition);
            p[i]++;
            p[index] = itemPosition;
            return p;
        });
        
        requestAnimationFrame(recomputeFromDOM);
        dispatchPositionsChanged();
    }
    return null;
    return (
        <div ref={buttonContainer} className="module-order episode-module-order">
            <button onClick={dec} disabled={_itemPosition == 0}>{'\u25B2'}</button>
            <button onClick={inc} disabled={_itemPosition == _count - 1}>{'\u25BC'}</button>
        </div>
    )
}
const Episode = () => {
    const { podcastName, imageUrl, role, podcastMetaData, isHosted } = useContext(AccessContext);
    const readOnly = role == 'Host/Guest';
    const navigate = useNavigate();
    const location = useLocation();
    const [id, setId] = useState(location.state?.id);
    const setContext = useContext(Context)[1];
    const addSponsorRef = useRef(null);
    const addVideoRef = useRef(null);
    const addImageRef = useRef(null);
    const cropperRef = useRef(null);
    const cropImageRef = useRef(null);
    const hostRef = useRef(null);
    const guestRef = useRef(null);
    const linkRef = useRef(null);
    const pollRef = useRef(null);
    const titleRef = useRef(null);
    const [crop, setCrop] = useState();
    const [pixelCrop, setPixelCrop] = useState();
    const [speakerSearch, setSpeakerSearch] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [tempArtworkURL, setTempArtworkURL] = useState(false);
    const [linkType, setLinkType] = useState(0);
    const getUrl = (path) => {
        if (!path)
            return undefined;
        if (path.startsWith('http'))
            return path;
        return `${process.env.REACT_APP_MEDIA_URL}${path}`;
    }
    function getVideoDetails(url) {
        const isYouTubeShort = url.includes('youtube.com/shorts/');
        const isTikTok = url.includes('tiktok.com');
        
        // Enhanced YouTube ID Regex to include shorts path
        const ytRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
        const match = url.match(ytRegExp);
        const videoId = match && match[2].length === 11 ? match[2] : null;

        return {
            videoId,
            isVertical: isYouTubeShort || isTikTok,
            isTikTok,
            isYouTube: !!videoId
        };
    }
    const getStandardVideos = () => {
        if (!episode?.videos?.length)
            return [];
        var videos = [];
        for (var i = 0; i < episode.videos.length; i++) {
            let video = episode.videos[i];
            let details = getVideoDetails(video.videoUrl);
            if (!details.isVertical)
                videos.push(video);
        }
        return videos;
    }
    const getShorts = () => {
        if (!episode?.videos?.length)
            return [];
        var videos = [];
        for (var i = 0; i < episode.videos.length; i++) {
            let video = episode.videos[i];
            let details = getVideoDetails(video.videoUrl);
            if (details.isVertical)
                videos.push(video);
        }
        return videos;
    }
    if (id)
        setContext('Edit Episode');
    else
        setContext('Add Episode');
    const getSocialIcon = (name) => {
        switch (name.toLowerCase()) {
            case 'facebook':
                return faFacebook;
            case 'x/twitter':
                return faXTwitter;
            case 'instagram':
                return faInstagram;
            case 'tiktok':
                return faTiktok;
            case 'youtube':
                return faYoutube;
            case 'website':
                return faGlobe
            case 'linkedin':
                return faLinkedin;
            case 'email':
                return faEnvelope;
        }
    }
    const formatDateTime = (d) => {
        let year = d.getFullYear();
        let month = String(d.getMonth() + 1).padStart(2, '0');
        let day = String(d.getDate()).padStart(2, '0');
        let hours = String(d.getHours()).padStart(2, '0');
        let minutes = String(d.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    const formatDate = (d) => {
        let year = d.getFullYear();
        let month = String(d.getMonth() + 1).padStart(2, '0');
        let day = String(d.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
    const formatTime = (d) => {
        let hours = String(d.getHours()).padStart(2, '0');
        let minutes = String(d.getMinutes()).padStart(2, '0');

        return `${hours}:${minutes}`;
    }
    const defaultEpisode = {
        title: '',
        description: '',
        season: 0,
        episode: 0,
        airDate: formatDateTime(new Date()),
        mediaUrl: '',
        isVideo: false,
        imageUrl: '',
        multiDirectoryUpload: false,
        readyToPublish: false,
        category: { id: 0, text: '' },
        toShow: {
            hosts: true,
            guests: true,
            videos: true,
            images: true,
            sponsors: true,
            merch: true,
            events: true,
            links: true
        },
        events: [],
        sponsors: [],
        merch: [],
        hosts: [],
        guests: [],
        images: [],
        videos: [],
        links: [],
        metaData: podcastMetaData?.contentType ? { contentType: podcastMetaData.contentType } : {}
    }
    const artworkInputRef = useRef(null);
    const mediaInputRef = useRef(null);
    const [episode, setEpisode] = useState(defaultEpisode);
    const [positions, setPositions] = useState([1, 2, 3, 4, 5, 6, 7, 8]);
    const [loading, setLoading] = useState(id ? true : false);
    const [sponsors, setSponsors] = useState([]);
    const [hosts, setHosts] = useState([]);
    const [guests, setGuests] = useState([]);
    const [downloadFile, setDownloadFile] = useState([]);
    const [downloadFP, setDownloadFP] = useState('');
    const [file, setFile] = useState([]);
    const [epFile, setEpFile] = useState(null);
    const [epFp, setEpFP] = useState('');
    const [artFile, setArtFile] = useState(null);
    const [artFp, setArtFP] = useState('');
    const [toAddImagesTitle, setToAddImagesTitle] = useState('');
    const [toAddVideoTitle, setToAddVideoTitle] = useState('');
    const [fp, setFP] = useState('');
    const [sponsorId, setSponsorId] = useState(-1);
    const [hostId, setHostId] = useState(-1);
    const [guestId, setGuestId] = useState(-1);
    const [videoContainerWidth, setVideoContainerWidth] = useState('100%');
    const [videoUrl, setVideoUrl] = useState('');
    const [categories, setCategories] = useState([]);
    const [newLinkText, setNewLinkText] = useState('');
    const [newLinkURL, setNewLinkURL] = useState('');
    const [mdUpload, setMdUpload] = useState([false, false, false, false, false, false, false, false]);
    const [duration, setDuration] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [mediaElement, setMediaElement] = useState(null);
    const [imageFiles, setImageFiles] = useState([]);
    const [isDownload, setIsDownload] = useState(false);
    const [linkAddSection, setLinkAddSection] = useState(0);
    const [titleFromFile, setTitleFromFile] = useState('');
    const isTracking = useRef(false);
    const [audioFiles, setAudioFiles] = useState([]);
    const [thumbnailFiles, setThumbnailFiles] = useState([]);
    const addAudioRef = useRef(null);
    const addThumbnailRef = useRef(null);
    const updateTracking = (e) => {
        if (!isTracking.current || !mediaElement)
            return;

        const rect = e.currentTarget.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        let p = clickX / rect.width;

        p = Math.min(Math.max(p, 0), 1);

        console.log(clickX, p);

        if (!isNaN(mediaElement.duration)) {
            const newTime = p * mediaElement.duration;
            mediaElement.currentTime = newTime;
            setCurrentTime(newTime);
        }
    }
    const setMetaData = (key, value) => {
        setEpisode(h => {
            let _h = { ...h };
            _h.metaData = _h.metaData || {};
            _h.metaData[key] = value;
            return _h;
        });
    }
    const toggleMdUpload = (i) => {
        if (readOnly)
            return;
        setMdUpload((md) => {
            var nMd = [...md];
            nMd[i] = !nMd[i];
            return nMd;
        })
    }
    const getAllMdUpload = () => {
        if (mdUpload.includes(false))
            return false;
        return true;
    }
    const toggleAllMdUpload = () => {
        if (readOnly)
            return;
        if (getAllMdUpload())
            setMdUpload([false, false, false, false, false, false, false, false]);
        else
            setMdUpload([true, true, true, true, true, true, true, true])
    }
    const isVisible = (i) => {
        switch (i) {
            case 0:
                return episode?.toShow?.hosts && episode?.hosts?.length;
            case 1:
                return episode?.toShow?.guests && episode?.guests?.length;
            case 2:
                return episode?.toShow?.videos && episode?.videos?.length;
            case 3:
                return episode?.toShow?.images && episode?.images?.length;
            case 4:
                return episode?.links?.length;
            case 5:
                return episode?.toShow?.sponsors && episode?.sponsors?.length;
            case 6:
                return episode?.toShow?.events && episode?.events?.length;
            case 7:
                return false;
        }
    }
    function getNextFreePosition(p, cur) {
        const taken = new Set(p);
        for (let i = 1; i <= 8; i++) {
            if (!taken.has(i)) return i;
        }
        return cur;
    }
    useEffect(() => {
        if (loading)
            return;
        /*for (var i = 0; i < positions.length; i++) {
            const __i = i;
            const index = positions.findIndex((v, _i) => v == positions[i] && __i != _i);
            if (index >= 0) {
                const indexToSwitch = isVisible(__i) ? (isVisible(index) ? __i : index) : __i;
                
                setPositions(_p => {
                    let p = [..._p];
                    p[indexToSwitch] = getNextFreePosition(p, p[indexToSwitch]);
                    return p;
                });
            }
        }*/
        /*var count = 0;
        for (var i = 0; i < positions.length; i++) {
            if (i == 6) {
                debugger;
            }
            if (isVisible(i)) count++;
        }
        for (var i = 0; i < positions.length; i++) {
            if (i == 6) {
                debugger;
            }
            if (!isVisible(i)) {
                count++;
                const val = count;
                const _i = i;
                if (positions[_i] != val) {
                    setPositions(_p => {
                        let p = [..._p];
                        p[_i] = val;
                        return p;
                    });
                }
            }
        }*/
    }, [positions]);
    const loadEpisode = () => {
        axios.post(process.env.REACT_APP_API_URL + 'episode', {
            id: id
        }).then(r => {
            if (r?.data?.status === 'Success') {
                if (r.data.results.moduleOrder) {
                    var mo = r.data.results.moduleOrder.split(',').map(n => parseInt(n));
                    while (mo.length < 8) {
                        mo.push(mo.length + 1);
                    }
                    setPositions(mo);
                }

                const podcastId = r.data.results.podcastId

                axios.post(process.env.REACT_APP_API_URL + 'podcast', {podcastId: podcastId}).then(r => {
                    setLoading(false);
                    if (r?.data?.status === 'Success') {
                        setEpisode(e => {
                            var episode = {...e};
                            episode.socials = r.data.results.socials;
                            episode.events = r.data.results.events;
                            var now = new Date();
                            episode.events = episode.events.filter(ev => {
                                ev.datetime = new Date(ev.datetime);
                                return ev.datetime > now;
                            });
                            episode.events.sort((a, b) => {
                                return a.datetime - b.datetime;
                            })
                            episode.merch = r.data.results.merch.map(m => {
                                m.images = JSON.parse(m.imageJson || '[]');
                                if (m.imageUrl)
                                    m.images.splice(0, 0, m.imageUrl);
                                return m;
                            });
                            return episode;
                        });
                    }
                });

                r.data.results.readyToPublish = true;

                r.data.results.events = r.data.results.events || [];
                r.data.results.sponsors = r.data.results.sponsors || [];
                r.data.results.merch = r.data.results.merch || [];
                r.data.results.hosts = r.data.results.hosts || [];
                r.data.results.guests = r.data.results.guests || [];
                r.data.results.images = r.data.results.images || [];
                r.data.results.videos = r.data.results.videos || [];
                r.data.results.links = r.data.results.links || [];
                r.data.results.metaData = r.data.results.metaData || {};
                
                setEpisode(r.data.results);

                if (!r.data.results.mediaUrl || r.data.results.mediaUrl == 'null')
                    return;

                let media;
                if (r.data.results.isVideo) {
                    media = document.createElement("video");
                } else {
                    media = document.createElement("audio");
                }

                media.src = r.data.results.mediaUrl.toLowerCase().startsWith('http') ? r.data.results.mediaUrl : process.env.REACT_APP_MEDIA_URL + r.data.results.mediaUrl;
                media.preload = "metadata";

                media.onloadedmetadata = () => {
                    setDuration((media.duration) | 0);
                };

                setMediaElement(media);
            } else {
                setLoading(false);
            }
        });
    }
    useEffect(() => {
        if (id) {
            loadEpisode();
        } else {
            axios.post(process.env.REACT_APP_API_URL + 'podcast').then(r => {
                setLoading(false);
                if (r?.data?.status === 'Success') {
                    setEpisode(e => {
                        var episode = {...e};
                        episode.imageUrl = r.data.results.imageUrl;
                        episode.title = r.data.results.defaultEpisodeTitle;
                        episode.socials = r.data.results.socials;
                        episode.events = r.data.results.events;
                        var now = new Date();
                        episode.events = episode.events.filter(ev => {
                            ev.datetime = new Date(ev.datetime);
                            return ev.datetime > now;
                        });
                        episode.merch = r.data.results.merch;
                        return episode;
                    });
                }
            });
        }
    }, [id]);
    useEffect(() => {
        axios.post(process.env.REACT_APP_API_URL + 'sponsor').then(r => {
            if (r?.data?.status === 'Success') {
                setSponsors(r.data.results);
            }
        });
        axios.post(process.env.REACT_APP_API_URL + 'podcast/speakers', {isGuest: 0}).then(r => {
            if (r?.data?.status === 'Success') {
                setHosts(r.data.results);
                if (!id) {
                    const primary = r.data.results.filter(s => s.isPrimary);
                    setEpisode( e => {
                        var episode = {...e};
                        episode.hosts = primary;
                        return episode;
                    });
                }
            }
        });
        axios.post(process.env.REACT_APP_API_URL + 'podcast/speakers', {isGuest: 1}).then(r => {
            if (r?.data?.status === 'Success') {
                setGuests(r.data.results);
            }
        });
        axios.post(process.env.REACT_APP_API_URL + 'categories').then(r => {
            if (r?.data?.status === 'Success') {
                setCategories(r.data.results);
            }
        });
    }, []);

    function formatDateString(dateInput) {
        const date = new Date(dateInput);

        // Format the date portion: "Apr 17, 2026"
        const datePart = date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });

        // Format the time portion: "2:41 PM"
        const timePart = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });

        // Combine them
        return `${datePart} at ${timePart}`;
    }
    useEffect(() => {
        if (episode.episode && !isHosted) {
            var title = episode.title;
            var match = title.match(/#[0-9]*(\s|$)/);
            if (match) {
                title = title.replace(/#[0-9]*(\s|$)/, '#' + episode.episode + '$1');
                setValue('title', title);
            }
        }
    }, [episode.episode]);
    const setValue =(key, value) => {
        setEpisode(h => {
            let _h = { ...h };
            _h[key] = value;
            return _h;
        });
    }
    const save = () => {
        const formData = new FormData();
        if (epFile)
            formData.append('isVideo', epFile?.type.includes('video') ? 1 : 0);
        else
            formData.append('isVideo', episode.isVideo);
        formData.append('media', epFile);
        formData.append('mediaUrl', episode.mediaUrl)
        formData.append('title', episode.title);
        formData.append('image', artFile);
        formData.append('imageUrl', episode.imageUrl);
        formData.append('duration', duration);
        formData.append('description', episode.description);
        if (episode.readyToPublish)
            formData.append('airDate', episode.airDate ? episode.airDate : '');
        else
            formData.append('airDate', '');
        formData.append('moduleOrder', positions.join(','));
        formData.append('season', episode.season);
        formData.append('episode', episode.episode);
        formData.append('metaData', JSON.stringify(episode.metaData || {}));
        formData.append('category', episode.category.id);
        formData.append('toShow', JSON.stringify(episode.toShow));
        formData.append('videos', JSON.stringify(episode.videos));
        formData.append('images', JSON.stringify((episode.images || []).map(h => h.id)));
        formData.append('sponsors', JSON.stringify((episode.sponsors || []).map(h => h.id)));
        formData.append('hosts', JSON.stringify((episode.hosts || []).map(h => h.id)));
        formData.append('guests', JSON.stringify((episode.guests || []).map(g => g.id)));
        formData.append('links', JSON.stringify((episode.links || []).map(l => ({text: l.text, url: l.url, isDownload: l.isDownload ? 1 : 0, type: l.type}))));
        if (!id) {
            axios.post(process.env.REACT_APP_API_URL + 'episode/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setId(r.data.id);
                    setFile([]);
                    setFP('');
                    setArtFile(null);
                    setEpFile(null);
                    setEpFP('');
                    setArtFP('');
                    setToAddImagesTitle('');
                    setToAddVideoTitle('');
                    setLoading(true);
                }
            });
        } else {
            formData.append('id', id);
            axios.post(process.env.REACT_APP_API_URL + 'episode/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setLoading(true);
                    setFile([]);
                    setFP('');
                    
                    setArtFile(null);
                    setEpFile(null);
                    setEpFP('');
                    setArtFP('');
                    setToAddImagesTitle('');
                    setToAddVideoTitle('');
                    loadEpisode();
                }
            });
        }
    }
    const _delete = () => {
        if (!id)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'episode/delete', {
            ids: JSON.stringify([id]),
            urls: JSON.stringify([...(episode.images?.map?.(i => i.imageUrl) || [])])
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                navigate('/episode-list');
            }
        });
    }

    const [currentTime, setCurrentTime] = useState(0);
    useEffect(() => {
        if (!mediaElement)
            return;
        const timeInterval = setInterval(() => {
            setCurrentTime(mediaElement.currentTime);
        }, 250);
        return () => {
            clearInterval(timeInterval);
        }
    }, [mediaElement]);
    useEffect(() => {
        return () => {
            if (mediaElement) {
                mediaElement.pause();
                mediaElement.src = "";
                setIsPlaying(false);
                //setMediaElement(null);
            }
        }
    }, [mediaElement]);

    const handlePlayPause = () => {
        if (!mediaElement)
            return;
        if (mediaElement.paused) {
            mediaElement.play();
            setIsPlaying(true);
        } else {
            mediaElement.pause();
            setIsPlaying(false);
        }
    }

    function isNumberArray(value) {
        return Array.isArray(value) && value.every(item => typeof item === 'number');
    }
    
    const filterArrays = (arrA, arrB) => {
        return (arrA || []).filter(a => {
            return !(arrB || []).some(b => {
                return a.id === b.id;
            });
        });
    }
    if (loading) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    const sponsorDialogClose = () => {
        setSponsorId(-1);
    }
    const videoDialogClose = () => {
        setVideoUrl('');
        setToAddVideoTitle('');
        setVideoContainerWidth('100%');
    }
    const imageDialogClose = () => {
        setImageFiles([]);
        setToAddImagesTitle('');
        setPixelCrop();
        setCrop();
    }
    const audioDialogClose = () => {
        setAudioFiles([]);
    }
    const thumbnailDialogClose = () => {
        setThumbnailFiles([]);
    }
    function extractTitleFromFile(fileName) {
        var parts = fileName.split('.');
        parts.pop();
        var f = parts.join('.');
        f = f.split(/[_-]/).join(' ');
        return f;
    }
    const getMaxId = (arr) => {
        if (arr.length === 0) return 0;
        return Math.max(...arr.map(item => item.id));
    };
    return (
        <main>
            <Dialog ref={addSponsorRef} onClose={sponsorDialogClose} title="Add Sponsor" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addSponsorRef.current.hide();
                        sponsorDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={sponsorId == -1} onClick={() => {
                        addSponsorRef.current.hide();
                        if (sponsorId == -1)
                            return;
                        var sp = sponsors.find(e => e.id == sponsorId);
                        if (!sp)
                            return;
                        setEpisode(_e => {
                            let e = { ..._e };
                            e.sponsors = e.sponsors || [];
                            e.sponsors.push(sp);
                            setSponsorId(-1);
                            return e;
                        });
                    }}>Add Sponsor</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, maxWidth: '100%', width: 400 }} className="w-100 p-rel">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row mb-10 flex f-wrap">
                        <select id="find-sponsor" className="w-100" onChange={(e) => setSponsorId(e.target.value)} value={sponsorId}>
                            <option value={-1}>
                                Please Select...
                            </option>
                            {filterArrays(sponsors, episode.sponsors).map((e, i) => (
                                <option key={i} value={e.id}>
                                    {e.id}: {e.type} - {e.name}
                                </option>
                            ))}
                        </select>
                        {sponsorId >= 0 && !!sponsors.find(e => e.id == sponsorId) ? <div className="preview-container mt-0"><SponsorCard sponsor={sponsors.find(e => e.id == sponsorId)} /></div> : (
                            <div className="no-video-preview w-100 mt-0">
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={addVideoRef} onClose={videoDialogClose} title="Add Video or Short" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addVideoRef.current.hide();
                        videoDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={videoUrl == ''} onClick={() => {
                        console.log("Adding Video Begin");
                        addVideoRef.current.hide();
                        if (videoUrl == '')
                            return;
                        var vid = episode.videos.find(v => v.videoUrl.toLowerCase() == videoUrl.toLowerCase());
                        if (vid) {
                            setVideoUrl('');
                            setToAddVideoTitle('');
                            return;
                        }
                        setEpisode(_e => {
                            let e = { ..._e };
                            e.videos = e.videos || [];
                            e.videos.push({ videoUrl: videoUrl, title: toAddVideoTitle, id: getMaxId(e.videos) + 1 });
                            setVideoUrl('');
                            setToAddVideoTitle('');
                            return e;
                        });
                    }}>Add Video</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, maxWidth: 400 }} className="w-100 p-rel">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row mb-10 flex f-wrap">
                        <label style={{marginBottom: -5}} htmlFor="find-video" className="w-100 text-sm">Video URL</label>
                        <input type="text" id="find-video" className="w-50" placeholder="Video URL" style={{flexGrow: 1}} value={videoUrl} onChange={e => {
                            setVideoUrl(e.target.value);
                            setVideoContainerWidth(e.target.value.toLowerCase().includes("shorts") || e.target.value.toLowerCase().includes("tiktok") ? 150 : '100%');
                        }} />
                        <label style={{marginBottom: -5}} className="mt-15 w-100 text-sm">Video Title (Optional)</label>
                        <input type="text" placeholder="Video Title" value={toAddVideoTitle} className="w-100" aria-label="Video Title" onChange={(e) => {
                            setToAddVideoTitle(e.target.value);
                        }} />
                        <label style={{marginBottom: -5}} className="w-100 mt-15 text-sm">Video Preview</label>
                        {!!videoUrl ? <div style={{width: videoContainerWidth}} className="preview-container mt-0"><VideoCard video={{
                            videoUrl: videoUrl, title: toAddVideoTitle
                        }} /></div> : (
                            <div className="no-video-preview w-100 mt-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <path d="M9.99902 5L33.3304 19.9987L9.99902 34.9975V5Z" stroke="#E5E7EB" stroke-width="3.33305" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={addImageRef} onClose={imageDialogClose} title="Add Image" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addImageRef.current.hide();
                        imageDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={imageFiles.length == 0 || !imageFiles[0].file || !imageFiles[0].thumbnail} onClick={() => {
                        if (imageFiles.length == 0 || !imageFiles[0].file)
                            return;
                        if (!imageFiles[0].thumbnail) {
                            toast.error('Create a thumbnail to continue');
                            return;
                        }
                        var formData = new FormData();
                        formData.append('image', imageFiles[0].file);
                        formData.append('thumbnail', imageFiles[0].thumbnail);
                        formData.append('title', toAddImagesTitle);
                        
                        axios.post(process.env.REACT_APP_API_URL + 'image/add', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(r => {
                            console.log(r);
                            if (r?.data?.status === 'Success') {
                                axios.post(process.env.REACT_APP_API_URL + 'image', {id: r.data.id})
                                    .then(_r => {
                                        if (_r?.data?.status === 'Success') {
                                            toast.success('Image Added');
                                            setEpisode(_e => {
                                                let e = { ..._e };
                                                e.images = e.images || [];
                                                e.images.push({
                                                    id: _r.data.results.id,
                                                    imageUrl: _r.data.results.imageUrl,
                                                    thumbnailUrl: _r.data.results.thumbnailUrl,
                                                    title: _r.data.results.title
                                                });
                                                return e;
                                            });
                                        }
                                        imageDialogClose();
                                        addImageRef.current.hide();
                                    });
                            }
                        });
                    }}>Add Image</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        {/*<input type="file" id="image-file" accept="image/*" style={{flexGrow: 1}} onChange={(e) => { setFile(e.target.files[0]); setFP(e.target.value) }} value={fp} />*/}
                        {!imageFiles || imageFiles.length == 0 ? (<FileDragDrop type="image" darkBackground files={imageFiles} setFiles={setImageFiles}
                        accept='image/png,image/jpg,image/jpeg,image/webp' acceptText="JPEG, JPG, PNG, WEBP" />) :
                        (
                            <div className="w-100 gap-10 f-col f-start flex f-wrap">
                                <label style={{marginBottom: -5}} className="text-sm">Image Title (Optional)</label>
                                <input type="text" placeholder="Image Title" value={toAddImagesTitle} className="w-100" aria-label="Image Title" onChange={(e) => setToAddImagesTitle(e.target.value)} />
                                <div className="flex gap-20 a-start w-100">
                                    <div className="flex gap-10 f-col w-60 f-start">
                                        <label className='mt-10 text-sm'>Image Preview</label>
                                        <div style={{width: '100%'}}>
                                            <img src={imageFiles[0].previewUrl} alt={toAddImagesTitle} />
                                            {!!toAddImagesTitle && (<div className="image-title">
                                                {toAddImagesTitle}
                                            </div>)}
                                        </div>
                                    </div>
                                    <div className="flex gap-10 f-col f-start w-40" style={{alignSelf: 'stretch'}}>
                                        <label className='mt-10 text-sm'>Thumbnail (required)</label>
                                        {!imageFiles[0].thumbnailUrl ? (
                                            <div
                                                role="button"
                                                onClick={() => {
                                                    cropperRef.current.show();
                                                }}
                                                className={`file-drop-container border-2 border-dashed rounded-lg p-30 cursor-pointer transition-shadow`}
                                                style={{ borderColor: 'rgba(156,163,175,0.6)', width: '100%', height: '100%', backgroundColor: '#F9FAFB' }}
                                                >
                                                <div className="text-center gap-5 flex f-col f-center a-center" style={{height: '100%', width: '100%', color: '#364153'}}>
                                                    <FontAwesomeIcon icon={faImage} style={{fontSize: 48}} />
                                                    <div style={{textDecoration: 'underline'}} className="mt-5 font-bold">Create<br />Tumbnail</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <img onClick={() => cropperRef.current.show()} style={{cursor: 'pointer'}} src={imageFiles[0].thumbnailUrl} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={cropperRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        cropperRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={!pixelCrop} onClick={() => {
                        if (!pixelCrop) {
                            toast.error('Please make a crop.')
                        }
                        var cropCanvas = document.createElement('canvas');
                        var scale = cropImageRef.current.naturalWidth / cropImageRef.current.width;
                        cropCanvas.width = pixelCrop.width * scale;
                        cropCanvas.height = pixelCrop.height * scale;
                        var ctx = cropCanvas.getContext('2d');
                        ctx.drawImage(
                            cropImageRef.current,
                            pixelCrop.x * scale,
                            pixelCrop.y * scale,
                            pixelCrop.width * scale,
                            pixelCrop.height * scale,
                            0,
                            0,
                            pixelCrop.width * scale,
                            pixelCrop.height * scale
                        );
                        cropCanvas.toBlob((b) => {
                            setImageFiles(i => {
                                var newI = [...i];
                                newI[0].thumbnail = b;
                                newI[0].thumbnailUrl = cropCanvas.toDataURL();
                                return newI;
                            });
                            cropperRef.current.hide();
                        });
                    }}>Add Thumbnail</button>
                </div>
            )}>
                {imageFiles?.length > 0 && (
                    <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => {
                            setCrop(percentCrop);
                        }}
                        onComplete={(c) => {
                            setPixelCrop(c);
                        }}
                        aspect={1}
                        minHeight={1}
                        >
                        <img ref={cropImageRef}
                            alt="Crop me"
                            style={{width: 400, maxWidth: '80vw'}}
                            src={imageFiles[0].previewUrl}
                        />
                    </ReactCrop>
                )}
            </Dialog>
            <Dialog ref={hostRef} title="Add Host" onClose={() => {
                setSpeakerSearch('');
            }} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        setSpeakerSearch('');
                        hostRef.current.hide();
                    }}>Cancel</button>
                </div>
            )}>
                {hosts?.length > 0 && (
                    <div style={{ flexGrow: 0 }} className="w-100 flex gap-20 f-col">
                        <input type="search" id="search-hosts" aria-label="search-hosts"
                            placeholder="Search Hosts" className="w-100" value={speakerSearch} onChange={(e) => setSpeakerSearch(e.target.value)}></input>
                        <div className="speaker-add-container" style={{height: 'min(483.2px, calc(80vh - 107px))'}}>
                            {!!speakerSearch ? (
                                <>
                                    {filterArrays(hosts, episode.hosts).filter(s => {
                                        return (s.firstName + ' ' + s.lastName).toLowerCase().includes(speakerSearch.toLowerCase())
                                    }).map((h, i) => (
                                        <div key={i}>
                                            <img src={h.imageUrl ? process.env.REACT_APP_MEDIA_URL + h.imageUrl : placeholderImage}
                                                alt={h.firstName + ' ' + h.lastName} width="32" height="32" />
                                            <div className="speaker-info-container">
                                                <span>{h.firstName} {h.lastName}</span>
                                                <span></span>
                                            </div>
                                            <button className="btn btn-white" onClick={() => {
                                                setEpisode(_e => {
                                                    let e = { ..._e };
                                                    e.hosts = e.hosts || [];
                                                    e.hosts.push(h);
                                                    return e;
                                                });
                                                setSpeakerSearch('');
                                                guestRef.current.hide();
                                            }}>Add</button>
                                        </div>
                                    ))}
                                    {filterArrays(hosts, episode.hosts).filter(s => {
                                        return (s.firstName + ' ' + s.lastName).toLowerCase().includes(speakerSearch.toLowerCase())
                                    }).length == 0 && (
                                        <div className="no-search-input" style={{color: '#B65'}}>No Host Profiles Found</div>
                                    )}
                                </>
                            ) : (
                                <div className="no-search-input">Search Host Profiles</div>
                            )}
                        </div>
                    </div>
                )}
            </Dialog>
            <Dialog ref={guestRef} title="Add Guest" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        setSpeakerSearch('');
                        guestRef.current.hide();
                    }}>Cancel</button>
                </div>
            )}>
                {guests?.length > 0 && (
                    <div style={{ flexGrow: 0 }} className="w-100 flex gap-20 f-col">
                        <input type="search" id="search-guests" aria-label="search-guests"
                            placeholder="Search Guests" className="w-100" value={speakerSearch} onChange={(e) => setSpeakerSearch(e.target.value)}></input>
                        <div className="speaker-add-container" style={{height: 'min(483.2px, calc(80vh - 107px))'}}>
                            {!!speakerSearch ? (
                                <>
                                    {filterArrays(guests, episode.guests).filter(s => {
                                        return (s.firstName + ' ' + s.lastName).toLowerCase().includes(speakerSearch.toLowerCase())
                                    }).map((h, i) => (
                                        <div key={i}>
                                            <img src={h.imageUrl ? process.env.REACT_APP_MEDIA_URL + h.imageUrl : placeholderImage}
                                                alt={h.firstName + ' ' + h.lastName} width="32" height="32" />
                                            <div className="speaker-info-container">
                                                <span>{h.firstName} {h.lastName}</span>
                                                <span></span>
                                            </div>
                                            <button className="btn btn-white" onClick={() => {
                                                setEpisode(_e => {
                                                    let e = { ..._e };
                                                    e.guests = e.guests || [];
                                                    e.guests.push(h);
                                                    return e;
                                                });
                                                setSpeakerSearch('');
                                                guestRef.current.hide();
                                            }}>Add</button>
                                        </div>
                                    ))}
                                    {filterArrays(guests, episode.guests).filter(s => {
                                        return (s.firstName + ' ' + s.lastName).toLowerCase().includes(speakerSearch.toLowerCase())
                                    }).length == 0 && (
                                        <div className="no-search-input" style={{color: '#B65'}}>No Guest Profiles Found</div>
                                    )}
                                </>
                            ) : (
                                <div className="no-search-input">Search Guest Profiles</div>
                            )}
                        </div>
                    </div>
                )}
            </Dialog>
            <Dialog ref={linkRef} onClose={() => {
                setNewLinkText('');
                setNewLinkURL('');
                setIsDownload(false);
                setLinkAddSection(0);
            }} title="Add Link or Download" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        setNewLinkText('');
                        setNewLinkURL('');
                        setLinkType(0);
                        setIsDownload(false);
                        setLinkAddSection(0);
                        linkRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={linkAddSection == 0} onClick={async () => {
                        if (newLinkText == '' || (newLinkURL == '' && (!downloadFile || downloadFile?.length == 0)))
                            return;
                        var link = episode?.links?.find?.(v => v.url.toLowerCase() == newLinkURL.toLowerCase() && v.text.toLowerCase() == newLinkText.toLowerCase());
                        if (link) {
                            setNewLinkText('');
                            setNewLinkURL('');
                            setLinkType(0);
                            setIsDownload(false);
                            setLinkAddSection(0);
                            linkRef.current.hide();
                            return;
                        }
                        var _newLinkUrl = newLinkURL;
                        if (isDownload) {
                            const formData = new FormData();
                            formData.append('file', downloadFile);
                            const data = await axios.post(process.env.REACT_APP_API_URL + 'file/upload', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            });
                            if (data.data.status != 'Success') {
                                toast.error('Failed to upload file.');
                                return;
                            }
                            _newLinkUrl = data.data.url;
                        }
                        setEpisode(_e => {
                            let e = { ..._e };
                            e.links = e.links || [];
                            e.links.push({ url: _newLinkUrl, text: newLinkText, isDownload: isDownload, type: linkType, id: getMaxId(e.links) + 1 });
                            setNewLinkText('');
                            setNewLinkURL('');
                            setLinkType(0);
                            setIsDownload(false);
                            setLinkAddSection(0);
                            return e;
                        });
                        linkRef.current.hide();
                    }}>Add</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500 }} className="w-100">
                    {linkAddSection == 0 && (
                        <div style={{ flexGrow: 0 }} className="flex w-100 gap-15 f-col">
                            <a role="button" className="add-link-type w-100 gap-10 flex f-center a-center"
                                style={{borderBottom: '1px solid'}}
                                onClick={() => {
                                    setLinkAddSection(1);
                                    setIsDownload(false);
                                }}>
                                <span>
                                    Create Web Link
                                </span>
                                <FontAwesomeIcon icon={faGlobe} className="add-icon" />
                            </a>
                            <a role="button" className="add-link-type w-100 gap-10 flex f-center a-center"
                                onClick={() => {
                                    setLinkAddSection(1);
                                    setIsDownload(true);
                                }}>
                                <span>
                                    Create Download
                                </span>
                                <FontAwesomeIcon icon={faDownload} className="add-icon" />
                            </a>
                        </div>
                    )}
                    {linkAddSection == 1 && (
                        <div style={{ flexGrow: 0 }} className="flex w-100 gap-10 f-row f-wrap">
                            <label style={{marginBottom: -5}} htmlFor="link-text" className="w-100 text-sm">{isDownload ? "Download Title" : "Web Link Title"}</label>
                            <input id="link-text" type="text" className="w-100" value={newLinkText} onChange={(e) => setNewLinkText(e.target.value)} />
                            {!isDownload && (
                                <>
                                    <label style={{marginBottom: -5}} htmlFor="link-type" className="mt-20 w-100 text-sm">Link Type</label>
                                    <select id="link-type" type="text" className="w-100" value={linkType} onChange={(e) => setLinkType(parseInt(e.target.value))}>
                                        <option value={0}>Website</option>
                                        <option value={1}>Product</option>
                                        <option value={2}>Article</option>
                                    </select>
                                </>
                            )}
                            <label style={{marginBottom: -5}} htmlFor="link-text" className="mt-20 w-100 text-sm">{isDownload ? "Upload File" : "Web Link URL"}</label>
                            {isDownload ? (
                                <input type="file" className="grow" value={downloadFP} onChange={(e) => {
                                    setDownloadFP(e.target.value);
                                    setDownloadFile(e.target.files[0]);
                                }} />
                            ) : (
                                <input id="link-url" type={"text"} className="grow" value={newLinkURL} onChange={(e) => setNewLinkURL(e.target.value)} />
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            <Dialog ref={pollRef} title="Add Poll" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        pollRef.current.hide();
                    }}>Cancel</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                    </div>
                </div>
            </Dialog>
            <Dialog ref={titleRef} title="Create Episode Title" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        setTitleFromFile('');
                        titleRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" onClick={() => {
                        setValue('title', titleFromFile);
                        setTitleFromFile('');
                        titleRef.current.hide();
                    }}>Add Title</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <label htmlFor="image-file" style={{display: 'block'}} className="mb-20">Would You Like To Use File Name As Episode Title?</label>
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        <label style={{marginBottom: -5}} className="text-sm">Episode Title</label>
                        <input type="text" value={titleFromFile} className="w-100" aria-label="Image Title" onChange={(e) => setTitleFromFile(e.target.value)} />
                    </div>
                </div>
            </Dialog>


            <Dialog ref={addAudioRef} onClose={audioDialogClose} title="Upload Audio File" subtitle="Supported formats: MP3, WAV, M4A, AAC, OGG, FLAC" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addAudioRef.current.hide();
                        audioDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={!audioFiles || audioFiles.length == 0} onClick={() => {
                        if (!audioFiles || audioFiles.length == 0)
                            return;
                        
                        setEpFile(audioFiles[0].file);
                        setIsPlaying(false);
                            
                        const url = audioFiles[0].previewUrl;
                        
                        let media;
                        if (audioFiles[0].file.type.startsWith("video/")) {
                            media = document.createElement("video");
                        } else {
                            media = document.createElement("audio");
                        }

                        setValue('mediaUrl', url);
                        media.src = url;
                        media.preload = "metadata";

                        media.onloadedmetadata = () => {
                            setDuration((media.duration) | 0);
                        };
                        setMediaElement(media);
                        setIsPlaying(false);
                        if (episode.title == "") {
                            setTitleFromFile(extractTitleFromFile(audioFiles[0].file.name));
                            titleRef.current.show();
                        }
                        addAudioRef.current.hide();
                        audioDialogClose();
                    }}>Save Audio</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        {!audioFiles || audioFiles.length == 0 ? (<FileDragDrop type="audio" hideFileTypes title="Drop audio file here" subTitle="or click to browse" darkBackground files={audioFiles} setFiles={setAudioFiles}
                        accept='audio/*' acceptText="JPEG, JPG, PNG" />) :
                        (
                            <div className="w-100 gap-10 f-col f-start flex f-wrap">
                                {audioFiles[0].file.type.startsWith("audio/") ? (
                                    <audio className="w-100" controls src={audioFiles[0].previewUrl} />
                                ) : (
                                    <video className="w-100" controls src={audioFiles[0].previewUrl} />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={addThumbnailRef} onClose={thumbnailDialogClose} title="Upload New Thumbnail" subtitle="Recommended: 1400×1400px · JPG or PNG · max 5 MB" outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addThumbnailRef.current.hide();
                        thumbnailDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={!thumbnailFiles || thumbnailFiles.length == 0} onClick={() => {
                        if (!thumbnailFiles || thumbnailFiles.length == 0)
                            return;
                        
                        setArtFile(thumbnailFiles[0].file);
                        
                        const url =thumbnailFiles[0].previewUrl;
                        setTempArtworkURL(url);
                        
                        addThumbnailRef.current.hide();
                        thumbnailDialogClose();
                    }}>Save Thumbnail</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        {!thumbnailFiles || thumbnailFiles.length == 0 ? (<FileDragDrop type="file" hideFileTypes
                            title="Drop image here"
                            subTitle="or click to browse"
                            darkBackground files={thumbnailFiles} setFiles={setThumbnailFiles}
                            accept='image/*' />) :
                        (
                            <div className="w-100 gap-10 f-col f-start flex f-wrap">
                                <img src={thumbnailFiles[0].previewUrl} className="w-100" />
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>

            <div className="container w-100 flex f-row a-start gap-20 episode-container">
                <div className="flex f-row f-wrap gap-10 a-center mb-20 episode-play-container">
                    {!!episode.mediaUrl ? (
                        <div className="w-100 flex f-col a-center b-radius-4 episode-content-card-container" style={{ background: '#155DFC' }}>
                            <div class="w-100 flex gap-10 p-10 f-row a-center episode-content-card">
                                <img className=""
                                    style={{aspectRatio: 1}}
                                    src={tempArtworkURL ? tempArtworkURL : episode.imageUrl ? (episode.imageUrl.toLowerCase().startsWith('http') ? episode.imageUrl : process.env.REACT_APP_MEDIA_URL + episode.imageUrl) : (imageUrl ? (imageUrl.toLowerCase().startsWith('http') ? imageUrl : process.env.REACT_APP_MEDIA_URL + imageUrl) : placeholderImage) }
                                    alt={episode.title} />
                                <div className={`episode-title`}>
                                    {(!!mediaElement && mediaElement.tagName != 'VIDEO') && (
                                        <>
                                            {!!podcastName && (
                                                <div className="episode-content-podcast">{podcastName}</div>
                                            )}
                                            <div className="episode-content-title">{episode.title || 'Untitled Episode'}</div>
                                        </>
                                    )}
                                </div>
                                {!!mediaElement && (
                                    <>
                                        {mediaElement.tagName == 'VIDEO' ? (
                                            <video src={mediaElement.src} controls style={{width: '100%', padding: '6%'}}></video>
                                        ) : (
                                            <>
                                                <button className="play-pause" onClick={handlePlayPause}>
                                                    <svg id="playPause" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                                        <path id="icon-3" stroke="#b02810" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"
                                                            d={isPlaying ? "M30,20 L42,20 L42,80 L30,80 Z M58,20 L70,20 L70,80 L58,80 Z"
                                                                : "M30,20 L75,50 L30,80 L30,80 Z M47,35 L75,50 L75,50 L47,65 Z"} />
                                                    </svg>
                                                </button>
                                                <div className="episode-content-player">
                                                    <div className="episode-content-play-time-container" onMouseMove={updateTracking} onMouseDown={(e) => {
                                                            isTracking.current = true;
                                                            updateTracking(e);
                                                        }} onMouseUp={() => isTracking.current = false}>
                                                        <div className="episode-content-play-time" style={{ width: `${(currentTime * 100  / (duration || 1)).toFixed(2)}%`, pointerEvents: 'none'}}></div>
                                                    </div>
                                                    {(duration > 0) && (
                                                        <div className="episode-content-current-time">
                                                            {String(Math.floor(duration / 3600)).padStart(1, '0')}:{String(Math.floor((duration % 3600) / 60)).padStart(2, '0')}:{String(Math.floor(((duration) % 60))).padStart(2, '0')}
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}

                                {!readOnly && !podcastMetaData?.rssFeedUrl && (
                                    <div className="upload-button-container">
                                        <a role="button" className="upload-btn w-50" style={{ flexGrow: 1 }} onClick={() => {
                                            addThumbnailRef.current.show();
                                        }}>
                                            Upload New Thumbnail
                                        </a>
                                        <input type="file" ref={artworkInputRef} accept="image/png,image/jpg,image/jpeg" style={{display: 'none'}} onChange={(e) => {
                                            setArtFP(e.target.value);
                                            setArtFile(e.target.files[0]);
                                            if (!e.target.files?.[0]) {
                                                return;
                                            }
                                            const url = URL.createObjectURL(e.target.files[0]);
                                            setTempArtworkURL(url);
                                        }} />
                                        <a role="button" className="upload-btn w-50" style={{ flexGrow: 1 }} onClick={() => {
                                            addAudioRef.current.show();
                                        }}>
                                            Upload Audio File
                                        </a>
                                        <input type="file" ref={mediaInputRef} accept="video/*,audio/*" style={{display: 'none'}} onChange={(e) => {
                                            const _fp = e.target.value;
                                            const _file = e.target.files;
                                            setEpFile(_file[0]);
                                            setEpFP(_fp);
                                            if (!_file?.[0]) {
                                                setIsPlaying(false);
                                                return;
                                            }
                                            const url = URL.createObjectURL(_file[0]);
                                            
                                            let media;
                                            if (_file[0].type.startsWith("video/")) {
                                                media = document.createElement("video");
                                            } else {
                                                media = document.createElement("audio");
                                            }

                                            media.src = url;
                                            media.preload = "metadata";

                                            media.onloadedmetadata = () => {
                                                setDuration((media.duration) | 0);
                                            };
                                            setMediaElement(media);
                                            setIsPlaying(false);
                                            if (episode.title == "") {
                                                setTitleFromFile(extractTitleFromFile(_file[0].name));
                                                titleRef.current.show();
                                            }
                                            e.target.value = null;
                                        }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <a role="button" className="no-episode-add" onClick={() => addAudioRef.current.show()}>
                            {episode.imageUrl ? (
                                <img src={episode.imageUrl.startsWith('http') ? episode.imageUrl : process.env.REACT_APP_MEDIA_URL + episode.imageUrl} alt={episode.title} />
                            ) : imageUrl ? (
                                <img src={imageUrl.startsWith('http') ? imageUrl : process.env.REACT_APP_MEDIA_URL + imageUrl} alt={episode.title} />
                            ) : (
                                <div className="no-episode-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <g clip-path="url(#clip0_623_2538)">
                                            <path d="M10 1.66797C9.33696 1.66797 8.70107 1.93136 8.23223 2.4002C7.76339 2.86904 7.5 3.50493 7.5 4.16797V10.0013C7.5 10.6643 7.76339 11.3002 8.23223 11.7691C8.70107 12.2379 9.33696 12.5013 10 12.5013C10.663 12.5013 11.2989 12.2379 11.7678 11.7691C12.2366 11.3002 12.5 10.6643 12.5 10.0013V4.16797C12.5 3.50493 12.2366 2.86904 11.7678 2.4002C11.2989 1.93136 10.663 1.66797 10 1.66797Z" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15.8337 8.33203V9.9987C15.8337 11.5458 15.2191 13.0295 14.1251 14.1235C13.0312 15.2174 11.5474 15.832 10.0003 15.832C8.45323 15.832 6.9695 15.2174 5.87554 14.1235C4.78157 13.0295 4.16699 11.5458 4.16699 9.9987V8.33203" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M10 15.832V18.332" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_623_2538">
                                                <rect width="20" height="20" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            )}
                            <div className="no-episode-text">
                                <div className="subtitle">No episode selected</div>
                                <div className="title"><u>Upload Episode File</u></div>
                            </div>
                            <div className="no-episode-play">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M3.99902 2L13.329 7.99786L3.99902 13.9957V2Z" stroke="#99A1AF" stroke-width="1.33286" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div className="no-episode-bar"></div>
                        </a>
                    )}

                    
                    <div className={`app-preview-container w-100 ${previewOpen ? 'preview-open' : ''}`}>
                        <div className="app-preview-title" role="button" onClick={() => {
                            setPreviewOpen(!previewOpen);
                        }}>
                            <span>
                                <div className="flex a-center f-row gap-10">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M5.99857 2H2.66643C2.29837 2 2 2.29837 2 2.66643V5.99857C2 6.36663 2.29837 6.665 2.66643 6.665H5.99857C6.36663 6.665 6.665 6.36663 6.665 5.99857V2.66643C6.665 2.29837 6.36663 2 5.99857 2Z" stroke="#99A1AF" stroke-width="1.33286" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M5.99857 9.32812H2.66643C2.29837 9.32812 2 9.6265 2 9.99455V13.3267C2 13.6948 2.29837 13.9931 2.66643 13.9931H5.99857C6.36663 13.9931 6.665 13.6948 6.665 13.3267V9.99455C6.665 9.6265 6.36663 9.32812 5.99857 9.32812Z" stroke="#99A1AF" stroke-width="1.33286" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.33008 2.66406H13.9951" stroke="#99A1AF" stroke-width="1.33286" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.33008 5.99609H13.9951" stroke="#99A1AF" stroke-width="1.33286" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.33008 9.99609H13.9951" stroke="#99A1AF" stroke-width="1.33286" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.33008 13.3281H13.9951" stroke="#99A1AF" stroke-width="1.33286" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Episode Content Previewer
                                </div>
                            </span>
                            <FontAwesomeIcon icon={faChevronDown} className="preview-toggle" />
                        </div>
                        <div className="expanding-section">
                            <div className="app-preview">
                                <div style={{order: -1}}>
                                    <Expandable title={<div className="flex a-center f-row gap-10">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <g clip-path="url(#clip0_623_1133)">
                                                <path d="M6.99503 1.16406C6.53118 1.16406 6.08633 1.34833 5.75835 1.67631C5.43036 2.0043 5.24609 2.44915 5.24609 2.913V6.99385C5.24609 7.4577 5.43036 7.90255 5.75835 8.23054C6.08633 8.55853 6.53118 8.74279 6.99503 8.74279C7.45888 8.74279 7.90373 8.55853 8.23172 8.23054C8.55971 7.90255 8.74397 7.4577 8.74397 6.99385V2.913C8.74397 2.44915 8.55971 2.0043 8.23172 1.67631C7.90373 1.34833 7.45888 1.16406 6.99503 1.16406Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M11.0758 5.82812V6.99408C11.0758 8.07639 10.6458 9.11437 9.88052 9.87968C9.11521 10.645 8.07723 11.0749 6.99492 11.0749C5.91261 11.0749 4.87463 10.645 4.10932 9.87968C3.34401 9.11437 2.91406 8.07639 2.91406 6.99408V5.82812" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6.99609 11.0781V12.8271" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_623_1133">
                                                    <rect width="13.9915" height="13.9915" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Ep. Details
                                    </div>}>
                                        <div className="app-episode-details flex gap-5">
                                            <div className="w-50">
                                                <div className="details-label">Episode</div>
                                                <div className="details-info"><b>#{episode.episode}</b></div>
                                            </div>
                                            <div className="w-50">
                                                <div className="details-label">Duration</div>
                                                <div className="details-info">{String(Math.floor((duration) / 60)).padStart(2, '0')}:{String(Math.floor(((duration) % 60))).padStart(2, '0')}</div>
                                            </div>
                                            <div dangerouslySetInnerHTML={{__html: episode?.description}} className="flex a-start app-standard-text"></div>
                                        </div>
                                    </Expandable>
                                </div>

                                {episode?.toShow?.hosts && episode?.hosts?.length ? (
                                    <div className="sortable-item" style={{order: positions[0]}}>
                                        <Expandable key="hosts" title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path d="M11.0758 12.244V11.078C11.0758 10.4595 10.8301 9.86642 10.3928 9.4291C9.95545 8.99178 9.36232 8.74609 8.74385 8.74609H5.24598C4.62752 8.74609 4.03438 8.99178 3.59706 9.4291C3.15975 9.86642 2.91406 10.4595 2.91406 11.078V12.244" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6.99598 6.41383C8.28386 6.41383 9.3279 5.3698 9.3279 4.08192C9.3279 2.79403 8.28386 1.75 6.99598 1.75C5.7081 1.75 4.66406 2.79403 4.66406 4.08192C4.66406 5.3698 5.7081 6.41383 6.99598 6.41383Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Hosts
                                            </div>} count={episode.hosts.length} reorder={<ModulePosition position={positions[0]} index="0" setPositions={setPositions} />}>
                                            <div style={{ flexDirection: 'column', width: '100%', height: '100%' }}>
                                                {episode?.hosts?.map(host =>
                                                    <AppSpeakerCard key={host.id} speaker={host} isHost={true} />
                                                )}
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                                {episode?.toShow?.guests && episode?.guests?.length ? (
                                    <div className="sortable-item" style={{order: positions[1]}}>
                                        <Expandable key="guests" title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path d="M11.0758 12.244V11.078C11.0758 10.4595 10.8301 9.86642 10.3928 9.4291C9.95545 8.99178 9.36232 8.74609 8.74385 8.74609H5.24598C4.62752 8.74609 4.03438 8.99178 3.59706 9.4291C3.15975 9.86642 2.91406 10.4595 2.91406 11.078V12.244" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6.99598 6.41383C8.28386 6.41383 9.3279 5.3698 9.3279 4.08192C9.3279 2.79403 8.28386 1.75 6.99598 1.75C5.7081 1.75 4.66406 2.79403 4.66406 4.08192C4.66406 5.3698 5.7081 6.41383 6.99598 6.41383Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Guests
                                            </div>} count={episode.guests.length} reorder={<ModulePosition position={positions[1]} index="1" setPositions={setPositions} />}>
                                            <div style={{ flexDirection: 'column', width: '100%', height: '100%' }}>
                                                {episode?.guests?.map(guest =>
                                                    <AppSpeakerCard key={guest.id} speaker={guest} isHost={false} />
                                                )}
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                                {episode?.toShow?.videos && getStandardVideos().length ? (
                                    <div className="sortable-item" style={{order: positions[2]}}>
                                        <Expandable title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_623_1253)">
                                                        <path d="M9.32812 7.57913L12.373 9.60907C12.4169 9.63828 12.4679 9.65503 12.5206 9.65755C12.5732 9.66007 12.6256 9.64826 12.6721 9.62337C12.7186 9.59849 12.7574 9.56146 12.7845 9.51623C12.8116 9.47101 12.826 9.41927 12.826 9.36655V4.58845C12.826 4.53716 12.8125 4.48678 12.7868 4.44238C12.7611 4.39799 12.7242 4.36116 12.6797 4.33561C12.6352 4.31006 12.5848 4.2967 12.5335 4.29688C12.4822 4.29705 12.4319 4.31075 12.3876 4.3366L9.32812 6.12169" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M8.16177 3.49609H2.33197C1.68803 3.49609 1.16602 4.01811 1.16602 4.66205V9.32589C1.16602 9.96983 1.68803 10.4918 2.33197 10.4918H8.16177C8.80571 10.4918 9.32772 9.96983 9.32772 9.32589V4.66205C9.32772 4.01811 8.80571 3.49609 8.16177 3.49609Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_623_1253">
                                                            <rect width="13.9915" height="13.9915" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Videos
                                            </div>} count={getStandardVideos().length} reorder={<ModulePosition position={positions[2]} index="2" setPositions={setPositions} />}>
                                            <div className="app-preview-video-container">
                                                {getStandardVideos().map((vid, i) => {
                                                    if (vid.videoUrl.toLowerCase().includes('youtu')) {
                                                        return (
                                                            <div key={vid.id} className="app-preview-video">
                                                                <YouTube videoId={
                                                                    vid.videoUrl.includes('watch?v') ?
                                                                        vid.videoUrl.match(/watch\?v=(.*?)(&|$)/)?.[1] :
                                                                        (vid.videoUrl.toLowerCase().includes('youtu.be') ?
                                                                            vid.videoUrl.match(/youtu.be\/(.*?)(&|$)/)?.[1] :
                                                                            vid.videoUrl.match(/embed\/(.*?)$/)?.[1])
                                                                } className="youtube-video" />
                                                            </div>
                                                        )
                                                    }
                                                    return (
                                                        <div key={vid.id} className="app-preview-video">
                                                            <video controls style={{borderColor: 'white', borderWidth: 1}} src={`${process.env.REACT_APP_MEDIA_URL}${vid.videoUrl}`} />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                                {episode?.toShow?.videos && getShorts().length ? (
                                    <div className="sortable-item" style={{order: positions[2]}}>
                                        <Expandable title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_623_1288)">
                                                        <path d="M9.90981 1.16406H4.08002C3.43608 1.16406 2.91406 1.68608 2.91406 2.33002V11.6577C2.91406 12.3016 3.43608 12.8236 4.08002 12.8236H9.90981C10.5538 12.8236 11.0758 12.3016 11.0758 11.6577V2.33002C11.0758 1.68608 10.5538 1.16406 9.90981 1.16406Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M6.99609 10.4922H7.00192" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_623_1288">
                                                            <rect width="13.9915" height="13.9915" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Shorts
                                            </div>} count={getShorts().length} reorder={<ModulePosition position={positions[2]} index="2" setPositions={setPositions} />}>
                                            <div className="app-preview-video-container is-shorts">
                                                {getShorts().map((vid, i) => {
                                                    if (vid.videoUrl.toLowerCase().includes('youtu')) {
                                                        return (
                                                            <div key={vid.id} className="app-preview-video">
                                                                <YouTubeShort videoId={getVideoDetails(vid.videoUrl).videoId} />
                                                            </div>
                                                        )
                                                    }
                                                    return (
                                                        <div key={vid.id} className="app-preview-video">
                                                            <video controls style={{borderColor: 'white', borderWidth: 1}} src={`${process.env.REACT_APP_MEDIA_URL}${vid.videoUrl}`} />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                                {episode?.toShow?.images && episode?.images?.length ? (
                                    <div className="sortable-item" style={{order: positions[3]}}>
                                        <Expandable title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path d="M11.0757 1.75H2.91401C2.27006 1.75 1.74805 2.27202 1.74805 2.91596V11.0777C1.74805 11.7216 2.27006 12.2436 2.91401 12.2436H11.0757C11.7197 12.2436 12.2417 11.7216 12.2417 11.0777V2.91596C12.2417 2.27202 11.7197 1.75 11.0757 1.75Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M5.24604 6.41395C5.88998 6.41395 6.41199 5.89193 6.41199 5.24799C6.41199 4.60405 5.88998 4.08203 5.24604 4.08203C4.6021 4.08203 4.08008 4.60405 4.08008 5.24799C4.08008 5.89193 4.6021 6.41395 5.24604 6.41395Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12.2427 8.74592L10.4437 6.94685C10.225 6.72826 9.9285 6.60547 9.61933 6.60547C9.31016 6.60547 9.01365 6.72826 8.795 6.94685L3.49805 12.2438" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Images
                                            </div>} count={episode.images.length} reorder={<ModulePosition position={positions[3]} index="3" setPositions={setPositions} />}>
                                            <div className="flex f-row" style={{ flexWrap: 'wrap', gap: 16 }}>
                                                {episode?.images?.map((img, i) => (
                                                    <div key={img.id} className="app-preview-images-container">
                                                        <img src={`${process.env.REACT_APP_MEDIA_URL}${img.thumbnailUrl || img.imageUrl}`} />
                                                    </div>
                                                ))}
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                                {episode?.links?.length ? (
                                    <div className="sortable-item" style={{order: positions[4]}}>
                                        <Expandable title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_623_1344)">
                                                        <path d="M5.24687 9.91182H4.08091C3.30783 9.91182 2.56642 9.60472 2.01977 9.05807C1.47312 8.51142 1.16602 7.77001 1.16602 6.99693C1.16602 6.22385 1.47312 5.48243 2.01977 4.93578C2.56642 4.38914 3.30783 4.08203 4.08091 4.08203H5.24687" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M8.74414 4.08203H9.9101C10.6832 4.08203 11.4246 4.38914 11.9712 4.93578C12.5179 5.48243 12.825 6.22385 12.825 6.99693C12.825 7.77001 12.5179 8.51142 11.9712 9.05807C11.4246 9.60472 10.6832 9.91182 9.9101 9.91182H8.74414" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M4.66406 6.99609H9.3279" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_623_1344">
                                                            <rect width="13.9915" height="13.9915" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Links
                                            </div>} count={episode.links.length} reorder={<ModulePosition position={positions[4]} index="4" setPositions={setPositions} />}>
                                            <div style={{display: 'flex', gap: 6, height: '100%', flexDirection: 'column'}}>
                                                {episode?.links?.map((link, i) => {
                                                    return (
                                                        <LinkCard key={i} link={link} preview />
                                                    );
                                                })}
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                                {episode?.toShow?.sponsors && episode?.sponsors?.length ? (
                                    <div className="sortable-item" style={{order: positions[5]}}>
                                        <Expandable title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_623_1385)">
                                                        <path d="M6.99609 1.16406V12.8236" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M9.91082 2.91406H5.53847C4.99732 2.91406 4.47833 3.12904 4.09567 3.51169C3.71302 3.89434 3.49805 4.41333 3.49805 4.95449C3.49805 5.49564 3.71302 6.01463 4.09567 6.39729C4.47833 6.77994 4.99732 6.99492 5.53847 6.99492H8.45337C8.99452 6.99492 9.51352 7.20989 9.89617 7.59254C10.2788 7.9752 10.4938 8.49419 10.4938 9.03534C10.4938 9.5765 10.2788 10.0955 9.89617 10.4781C9.51352 10.8608 8.99452 11.0758 8.45337 11.0758H3.49805" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_623_1385">
                                                            <rect width="13.9915" height="13.9915" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Sponsors
                                            </div>} count={episode.sponsors.length} reorder={<ModulePosition position={positions[5]} index="5" setPositions={setPositions} />}>
                                            <div className="flex gap-15" style={{flexDirection: 'column'}}>
                                                {episode?.sponsors?.map((sponsor, i) => {
                                                    return <SponsorCard sponsor={sponsor} preview key={i} />
                                                })}
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                                {episode?.toShow?.merch && episode?.merch?.length ? (
                                    <div className="sortable-item" style={{order: positions[6]}}>
                                        <Expandable title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_623_1437)">
                                                        <path d="M11.8807 2.01521L9.32721 1.16406C9.32721 1.78253 9.08152 2.37566 8.6442 2.81298C8.20688 3.2503 7.61375 3.49598 6.99529 3.49598C6.37683 3.49598 5.78369 3.2503 5.34638 2.81298C4.90906 2.37566 4.66337 1.78253 4.66337 1.16406L2.10992 2.01521C1.84606 2.10312 1.62231 2.28246 1.47906 2.52085C1.3358 2.75925 1.28249 3.041 1.32873 3.31526L1.66686 5.33819C1.68906 5.47514 1.75937 5.59969 1.86515 5.68945C1.97094 5.77921 2.10527 5.8283 2.24401 5.8279H3.49741V11.6577C3.49741 12.299 4.0221 12.8236 4.66337 12.8236H9.32721C9.63644 12.8236 9.933 12.7008 10.1517 12.4821C10.3703 12.2635 10.4932 11.9669 10.4932 11.6577V5.8279H11.7466C11.8853 5.8283 12.0196 5.77921 12.1254 5.68945C12.2312 5.59969 12.3015 5.47514 12.3237 5.33819L12.6618 3.31526C12.7081 3.041 12.6548 2.75925 12.5115 2.52085C12.3683 2.28246 12.1445 2.10312 11.8807 2.01521Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_623_1437">
                                                            <rect width="13.9915" height="13.9915" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Merch
                                            </div>} count={episode.merch.length} reorder={<ModulePosition position={positions[6]} index="6" setPositions={setPositions} />}>
                                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', alignItems: 'flex-start', justifyContent: 'flex-start', rowGap: 20, columnGap: 12 }}>
                                                {episode?.merch?.map(merch => {
                                                    return (
                                                        <div key={merch?.id} className="app-preview-merch">
                                                            <div className="p-rel">
                                                                <img src={merch?.images?.length == 0 ? placeholderImage : `${process.env.REACT_APP_MEDIA_URL}${merch?.images?.[0]}`} />
                                                                <div className="app-preview-merch-price">${merch?.price?.toFixed?.(0)}</div>
                                                            </div>
                                                            <div className="text-snippet snippet-1 app-preview-merch-name">{merch?.name}</div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                                {episode?.toShow?.events && episode?.events?.length ? (
                                    <div className="sortable-item" style={{order: positions[7]}}>
                                        <Expandable title={<div className="flex a-center f-row gap-10">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path d="M4.66406 1.16406V3.49598" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M9.32812 1.16406V3.49598" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M11.0757 2.33203H2.91401C2.27006 2.33203 1.74805 2.85405 1.74805 3.49799V11.6597C1.74805 12.3036 2.27006 12.8257 2.91401 12.8257H11.0757C11.7197 12.8257 12.2417 12.3036 12.2417 11.6597V3.49799C12.2417 2.85405 11.7197 2.33203 11.0757 2.33203Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M1.74805 5.82812H12.2417" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Events
                                            </div>} count={episode.events.length} reorder={<ModulePosition position={positions[7]} index="7" setPositions={setPositions} />}>
                                            <div>
                                                <div className="flex gap-10" style={{ flexDirection: 'row', alignItems: 'stretch', minWidth: '100%', flexDirection: 'column' }}>
                                                    {episode?.events?.map(event =>
                                                        <AppEventCard key={event.id} event={event} />
                                                    )}
                                                </div>
                                            </div>
                                        </Expandable>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form speaker-form f-start" style={{ order: 1 }}>
                    <Expandable title="Episode Info" subTitle={(
                        <>
                            Title, Description, Season & Episode<br />
                            Number, Category, and Hosts & Guests
                        </>
                    )}>
                        <div className="w-100 sm-w-100 pt-10 pb-10 p-rel">
                            <div className="w-100 gap-10 f-row f-wrap">
                                {/*<div className="w-100 f-row gap-20">
                                    <div className="w-35 sm-w-100" style={{flexGrow: 0}}>
                                        <FileDragDrop onDrop={(_file, _fp) => {
                                                setEpFile(_file[0]);
                                                setEpFP(_fp);
                                                if (!_file?.[0]) {
                                                    setDuration(0);
                                                }
                                                const url = URL.createObjectURL(_file[0]);
                                                
                                                let media;
                                                if (_file[0].type.startsWith("video/")) {
                                                    media = document.createElement("video");
                                                } else {
                                                    media = document.createElement("audio");
                                                }

                                                media.src = url;
                                                media.preload = "metadata";

                                                media.onloadedmetadata = () => {
                                                    setDuration((media.duration * 1000) | 0);
                                                    URL.revokeObjectURL(url);
                                                };
                                            }}
                                            text="Drag Audio or Video File Here or Choose A File"
                                            accept='video/*,audio/*' fp={epFp}
                                            fileName={epFile?.name} />
                                    </div>
                                    <div className="w-65 sm-w-100">
                                        {!!episode.mediaUrl && (
                                            <>
                                                <label>Episode Preview</label>
                                                {episode.isVideo ? (
                                                    <video controls src={process.env.REACT_APP_MEDIA_URL + episode.mediaUrl} className="w-100 asp-16-9"></video>
                                                ) : (
                                                    <AudioPlayer src={process.env.REACT_APP_MEDIA_URL + episode.mediaUrl} />
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>*/}
                                <div className="w-100 sm-w-100 xs-w-100">
                                    <div className="flex f-row w-100">
                                        <label htmlFor="title">Episode Title</label>
                                    
                                        {(!isHosted || readOnly) && (<div className="ml-auto f-row gap-10" style={{flexGrow: 0}}>
                                            <label htmlFor="private-episode">Private</label>
                                            <label className="switch mb-0">
                                                <input type="checkbox" id="private-episode" readOnly={readOnly} onChange={e => {
                                                    if (readOnly)
                                                        return;
                                                    setMetaData('private', e.target.checked);
                                                }} checked={episode.metaData.private} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>)}
                                    </div>
                                    <input type="text" id="title" readOnly={readOnly || isHosted} value={episode.title} maxLength={200} onChange={(e) => setValue('title', e.target.value)} />
                                    <div className="ml-auto mt-5 xs-text" style={{ color: '#585858' }}>
                                        {episode.title.length}/200
                                    </div>
                                </div>
                                <div className="w-30 sm-w-30 xs-w-100">
                                    <label htmlFor="season">Season Number</label>
                                    <input type="text" id="season" readOnly={readOnly || isHosted} value={episode.season || ''} onChange={(e) => setValue('season', parseInt(e.target.value.replace(/[^0-9]/g, '') || '0'))} />
                                </div>
                                <div className="w-30 sm-w-30 xs-w-100">
                                    <label htmlFor="episode">Episode Number</label>
                                    <input type="text" id="episode" readOnly={readOnly || isHosted} value={episode.episode || ''} onChange={(e) => setValue('episode', parseInt(e.target.value.replace(/[^0-9]/g, '') || '0'))} />
                                </div>
                                <div className="w-40 sm-w-40 xs-w-100">
                                    <label htmlFor="category">Podcast Category</label>
                                    <select id="category" className="w-100" readOnly={readOnly} onChange={(e) => !readOnly && setValue('category', { id: parseInt(e.target.value), text: e.target.text })} value={episode.category.id}>
                                        <option value={0}>
                                            Please Select...
                                        </option>
                                        {categories.map((c, i) => (
                                            <option key={i} value={c.id}>
                                                {c.text}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="w-50 sm-w-50 xs-w-100">
                                    <label htmlFor="episode-type">Episode Type</label>
                                    <select id="episode-type" className="w-100" disabled={readOnly || isHosted} value={episode.metaData?.episodeType || 'full'}
                                        onChange={e => !(readOnly || isHosted) && setMetaData('episodeType', e.target.value)}>
                                        <option value="full">
                                            Full
                                        </option>
                                        <option value="trailer">
                                            Trailer
                                        </option>
                                        <option value="bonus">
                                            Bonus
                                        </option>
                                    </select>
                                </div>
                                <div className="w-50 sm-w-50 xs-w-100">
                                    <label htmlFor="episode-type">Episode Content</label>
                                    <select id="episode-type" className="w-100" readOnly={readOnly} value={Number(episode.metaData?.contentType)}
                                        onChange={e => setMetaData('contentType', e.target.value)}>
                                        <option value={0}>
                                            Clean
                                        </option>
                                        <option value={1}>
                                            Explicit
                                        </option>
                                    </select>
                                </div>
                                <div className="w-100 sm-w-100 xs-w-100">
                                    <label htmlFor="description">Episode Description</label>
                                    {readOnly ? (
                                        <textarea rows="12" id="description" readOnly={readOnly} value={episode.description} />
                                    ) : <RTE value={episode.description} setValue={(v) => setValue('description', v)} />}
                                </div>
                                
                                <div style={{ marginBottom: '-16px' }}>
                                    <label>Hosts</label>
                                </div>
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                    {/*<ModulePosition position={positions[0]} index="0" setPositions={setPositions} />*/}
                                    
                                    <div className="w-100 gap-10 card-container speaker-card-container">
                                        {episode.hosts?.length ? episode.hosts.map((h, i) => {
                                            return (
                                                <SpeakerCard speaker={h} onRemove={!readOnly && ((_id) => {
                                                    var index = episode.hosts.findIndex(h => h.id == _id);
                                                    if (index < 0)
                                                        return;
                                                    setEpisode(_e => {
                                                        let e = { ..._e };
                                                        e.hosts.splice(index, 1);
                                                        return e;
                                                    });
                                                })} key={i} />
                                            );
                                        }) : null}
                                        {!readOnly && (
                                            <button className="add-item add-item-2" onClick={() => {
                                                hostRef.current.show();
                                            }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M18.9931 20.994V18.9947C18.9931 17.9342 18.5718 16.9171 17.8219 16.1673C17.072 15.4174 16.055 14.9961 14.9945 14.9961H8.99663C7.93614 14.9961 6.91908 15.4174 6.1692 16.1673C5.41932 16.9171 4.99805 17.9342 4.99805 18.9947V20.994" stroke="#99A1AF" stroke-width="1.99929" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M11.9966 10.9972C14.205 10.9972 15.9952 9.20694 15.9952 6.99858C15.9952 4.79023 14.205 3 11.9966 3C9.78827 3 7.99805 4.79023 7.99805 6.99858C7.99805 9.20694 9.78827 10.9972 11.9966 10.9972Z" stroke="#99A1AF" stroke-width="1.99929" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <span><b>Add Host</b></span>
                                            </button>
                                        )}
                                    </div>
                                </div>

                                <div style={{ marginBottom: '-16px' }}>
                                    <label>Guests</label>
                                </div>
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                    {/*<ModulePosition position={positions[1]} index="1" setPositions={setPositions} />*/}
                                    
                                    <div className="w-100 gap-10 card-container speaker-card-container">
                                        {episode.guests?.length ? episode.guests.map((h, i) => {
                                            return (
                                                <SpeakerCard speaker={h} onRemove={!readOnly && ((_id) => {
                                                    var index = episode.guests.findIndex(h => h.id == _id);
                                                    if (index < 0)
                                                        return;
                                                    setEpisode(_e => {
                                                        let e = { ..._e };
                                                        e.guests.splice(index, 1);
                                                        return e;
                                                    });
                                                })} key={i} />
                                            );
                                        }) : null}
                                        {!readOnly && (
                                            <button className="add-item add-item-2" onClick={() => {
                                                guestRef.current.show();
                                            }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M15.995 20.994V18.9947C15.995 17.9342 15.5738 16.9171 14.8239 16.1673C14.074 15.4174 13.0569 14.9961 11.9965 14.9961H5.99858C4.93809 14.9961 3.92104 15.4174 3.17116 16.1673C2.42128 16.9171 2 17.9342 2 18.9947V20.994" stroke="#99A1AF" stroke-width="1.99929" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8.99663 10.9972C11.205 10.9972 12.9952 9.20694 12.9952 6.99858C12.9952 4.79023 11.205 3 8.99663 3C6.78827 3 4.99805 4.79023 4.99805 6.99858C4.99805 9.20694 6.78827 10.9972 8.99663 10.9972Z" stroke="#99A1AF" stroke-width="1.99929" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M21.9931 20.9929V18.9936C21.9924 18.1077 21.6975 17.247 21.1547 16.5468C20.6119 15.8466 19.852 15.3465 18.9941 15.125" stroke="#99A1AF" stroke-width="1.99929" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M15.9941 3.12891C16.8543 3.34913 17.6166 3.84935 18.161 4.55071C18.7054 5.25207 19.0009 6.11468 19.0009 7.00253C19.0009 7.89039 18.7054 8.75299 18.161 9.45435C17.6166 10.1557 16.8543 10.6559 15.9941 10.8762" stroke="#99A1AF" stroke-width="1.99929" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                <span><b>Add Guest</b></span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Expandable>

                    <Expandable title="Enhanced Media" subTitle={(
                        <>
                            Add episode specific media and content like<br />
                            videos, images, links and polls
                        </>
                    )}>
                        <div className="w-100 sm-w-100 pt-10 pb-10 p-rel gap-10 f-wrap f-row">
                            <div style={{ marginBottom: '-16px' }}>
                                <label className="flex-label">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <g clip-path="url(#clip0_623_155)">
                                            <path d="M9.32812 7.57913L12.373 9.60907C12.4169 9.63828 12.4679 9.65503 12.5206 9.65755C12.5732 9.66007 12.6256 9.64826 12.6721 9.62337C12.7186 9.59849 12.7574 9.56146 12.7845 9.51623C12.8116 9.47101 12.826 9.41927 12.826 9.36655V4.58845C12.826 4.53716 12.8125 4.48678 12.7868 4.44238C12.7611 4.39799 12.7242 4.36116 12.6797 4.33561C12.6352 4.31006 12.5848 4.2967 12.5335 4.29688C12.4822 4.29705 12.4319 4.31075 12.3876 4.3366L9.32812 6.12169" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8.16177 3.49609H2.33197C1.68803 3.49609 1.16602 4.01811 1.16602 4.66205V9.32589C1.16602 9.96983 1.68803 10.4918 2.33197 10.4918H8.16177C8.80571 10.4918 9.32772 9.96983 9.32772 9.32589V4.66205C9.32772 4.01811 8.80571 3.49609 8.16177 3.49609Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_623_155">
                                                <rect width="13.9915" height="13.9915" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Videos
                                    <a role="button" className="flex-label-add" onClick={() => {
                                        addVideoRef.current.show();
                                    }}>
                                        + Add
                                    </a>
                                </label>
                            </div>
                            {getStandardVideos().length ? (
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                    {/*<ModulePosition position={positions[2]} index="2" setPositions={setPositions} />*/}
                                    <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={getStandardVideos()}
                                        onOrderChange={(newList) => {
                                            setEpisode(h => {
                                                var newH = {...h};
                                                newH.videos = newList;
                                                return newH;
                                            });
                                        }}
                                        itemClass="card-item"
                                        renderItem={(h, i) => (
                                            <>
                                                <VideoCard video={h} onRemove={!readOnly && ((vu) => {
                                                    var index = episode.videos.findIndex(h => h.videoUrl == vu);
                                                    if (index < 0)
                                                        return;
                                                    setEpisode(_e => {
                                                        let e = { ..._e };
                                                        e.videos.splice(index, 1);
                                                        return e;
                                                    });
                                                })} key={i} />
                                            </>
                                        )} endItem={
                                            <div className="card-item">
                                                <button className="add-item" onClick={() => {
                                                    addVideoRef.current.show();
                                                }}>
                                                    <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                    <span>Add Video</span>
                                                </button>
                                            </div>
                                        } />
                                </div>
                            ) : (
                                <div className="w-100">
                                    <div className="w-100">
                                        <button className="add-item full-width" onClick={() => {
                                            addVideoRef.current.show();
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                <g clip-path="url(#clip0_623_155)">
                                                    <path d="M9.32812 7.57913L12.373 9.60907C12.4169 9.63828 12.4679 9.65503 12.5206 9.65755C12.5732 9.66007 12.6256 9.64826 12.6721 9.62337C12.7186 9.59849 12.7574 9.56146 12.7845 9.51623C12.8116 9.47101 12.826 9.41927 12.826 9.36655V4.58845C12.826 4.53716 12.8125 4.48678 12.7868 4.44238C12.7611 4.39799 12.7242 4.36116 12.6797 4.33561C12.6352 4.31006 12.5848 4.2967 12.5335 4.29688C12.4822 4.29705 12.4319 4.31075 12.3876 4.3366L9.32812 6.12169" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8.16177 3.49609H2.33197C1.68803 3.49609 1.16602 4.01811 1.16602 4.66205V9.32589C1.16602 9.96983 1.68803 10.4918 2.33197 10.4918H8.16177C8.80571 10.4918 9.32772 9.96983 9.32772 9.32589V4.66205C9.32772 4.01811 8.80571 3.49609 8.16177 3.49609Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_623_155">
                                                        <rect width="13.9915" height="13.9915" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>No videos added yet</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                            
                            <div style={{ marginBottom: '-16px' }} className="section-divider">
                                <label className="flex-label">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <g clip-path="url(#clip0_623_696)">
                                            <path d="M9.90981 1.16406H4.08002C3.43608 1.16406 2.91406 1.68608 2.91406 2.33002V11.6577C2.91406 12.3016 3.43608 12.8236 4.08002 12.8236H9.90981C10.5538 12.8236 11.0758 12.3016 11.0758 11.6577V2.33002C11.0758 1.68608 10.5538 1.16406 9.90981 1.16406Z" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M6.99609 10.4922H7.00192" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_623_696">
                                                <rect width="13.9915" height="13.9915" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Shorts
                                    <a role="button" className="flex-label-add" onClick={() => {
                                        addVideoRef.current.show();
                                    }}>
                                        + Add
                                    </a>
                                </label>
                            </div>
                            {!!getShorts().length ? (
                                <>
                                    <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                        {/*<ModulePosition position={positions[2]} index="2" setPositions={setPositions} />*/}
                                        <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={getShorts()}
                                            onOrderChange={(newList) => {
                                                setEpisode(h => {
                                                    var newH = {...h};
                                                    newH.videos = newList;
                                                    return newH;
                                                });
                                            }}
                                            itemClass="card-item-2"
                                            renderItem={(h, i) => (
                                                <>
                                                    <VideoCard video={h} onRemove={!readOnly && ((vu) => {
                                                        var index = episode.videos.findIndex(h => h.videoUrl == vu);
                                                        if (index < 0)
                                                            return;
                                                        setEpisode(_e => {
                                                            let e = { ..._e };
                                                            e.videos.splice(index, 1);
                                                            return e;
                                                        });
                                                    })} key={i} />
                                                </>
                                            )} endItem={
                                                <div className="card-item card-item-2">
                                                    <button className="add-item" style={{height: '100%'}} onClick={() => {
                                                        addVideoRef.current.show();
                                                    }}>
                                                        <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                        <span>Add Short</span>
                                                    </button>
                                                </div>
                                            } />
                                    </div>
                                </>
                            ) : (
                                <div className="w-100">
                                    <div className="w-100">
                                        <button className="add-item full-width" onClick={() => {
                                            addVideoRef.current.show();
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                <g clip-path="url(#clip0_623_696)">
                                                    <path d="M9.90981 1.16406H4.08002C3.43608 1.16406 2.91406 1.68608 2.91406 2.33002V11.6577C2.91406 12.3016 3.43608 12.8236 4.08002 12.8236H9.90981C10.5538 12.8236 11.0758 12.3016 11.0758 11.6577V2.33002C11.0758 1.68608 10.5538 1.16406 9.90981 1.16406Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6.99609 10.4922H7.00192" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_623_696">
                                                        <rect width="13.9915" height="13.9915" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>No shorts added yet</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                            
                            <div style={{ marginBottom: '-16px' }} className="section-divider">
                                <label className="flex-label">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M11.0757 1.75H2.91401C2.27006 1.75 1.74805 2.27202 1.74805 2.91596V11.0777C1.74805 11.7216 2.27006 12.2436 2.91401 12.2436H11.0757C11.7197 12.2436 12.2417 11.7216 12.2417 11.0777V2.91596C12.2417 2.27202 11.7197 1.75 11.0757 1.75Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M5.24604 6.41395C5.88998 6.41395 6.41199 5.89193 6.41199 5.24799C6.41199 4.60405 5.88998 4.08203 5.24604 4.08203C4.6021 4.08203 4.08008 4.60405 4.08008 5.24799C4.08008 5.89193 4.6021 6.41395 5.24604 6.41395Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M12.2427 8.74592L10.4437 6.94685C10.225 6.72826 9.9285 6.60547 9.61933 6.60547C9.31016 6.60547 9.01365 6.72826 8.795 6.94685L3.49805 12.2438" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Images
                                    <a role="button" className="flex-label-add" onClick={() => {
                                        addImageRef.current.show();
                                    }}>
                                        + Add
                                    </a>
                                </label>
                            </div>
                            {episode.images?.length ? (
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                    {/*<ModulePosition position={positions[3]} index="3" setPositions={setPositions} />*/}
                                    <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={episode.images ?? []}
                                        onOrderChange={(newList) => {
                                            setEpisode(h => {
                                                var newH = {...h};
                                                newH.images = newList;
                                                return newH;
                                            });
                                        }}
                                        itemClass="card-item-2"
                                        renderItem={(h, i) => (
                                            <>
                                                <ImageCard image={h} onRemove={!readOnly && ((_id) => {
                                                    var index = episode.images.findIndex(h => h.id == _id);
                                                    if (index < 0)
                                                        return;
                                                    setEpisode(_e => {
                                                        let e = { ..._e };
                                                        e.images.splice(index, 1);
                                                        return e;
                                                    });
                                                })} key={i} />
                                            </>
                                        )} endItem={
                                            <div className="card-item card-item-2">
                                                <button className="add-item add-item-2 aspect-1" onClick={() => {
                                                    addImageRef.current.show();
                                                }}>
                                                    <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                    <span>Add Image</span>
                                                </button>
                                            </div>
                                        } />
                                </div>
                            ) : (
                                <div className="w-100">
                                    <div className="w-100">
                                        <button className="add-item full-width" onClick={() => {
                                            addImageRef.current.show();
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                <path d="M11.0757 1.75H2.91401C2.27006 1.75 1.74805 2.27202 1.74805 2.91596V11.0777C1.74805 11.7216 2.27006 12.2436 2.91401 12.2436H11.0757C11.7197 12.2436 12.2417 11.7216 12.2417 11.0777V2.91596C12.2417 2.27202 11.7197 1.75 11.0757 1.75Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M5.24604 6.41395C5.88998 6.41395 6.41199 5.89193 6.41199 5.24799C6.41199 4.60405 5.88998 4.08203 5.24604 4.08203C4.6021 4.08203 4.08008 4.60405 4.08008 5.24799C4.08008 5.89193 4.6021 6.41395 5.24604 6.41395Z" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12.2427 8.74592L10.4437 6.94685C10.225 6.72826 9.9285 6.60547 9.61933 6.60547C9.31016 6.60547 9.01365 6.72826 8.795 6.94685L3.49805 12.2438" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <span>No images added yet</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                            
                            <div style={{ marginBottom: '-16px' }} className="section-divider">
                                <label className="flex-label">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <g clip-path="url(#clip0_623_220)">
                                            <path d="M5.24687 9.91182H4.08091C3.30783 9.91182 2.56642 9.60472 2.01977 9.05807C1.47312 8.51142 1.16602 7.77001 1.16602 6.99693C1.16602 6.22385 1.47312 5.48243 2.01977 4.93578C2.56642 4.38914 3.30783 4.08203 4.08091 4.08203H5.24687" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8.74414 4.08203H9.9101C10.6832 4.08203 11.4246 4.38914 11.9712 4.93578C12.5179 5.48243 12.825 6.22385 12.825 6.99693C12.825 7.77001 12.5179 8.51142 11.9712 9.05807C11.4246 9.60472 10.6832 9.91182 9.9101 9.91182H8.74414" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M4.66406 6.99609H9.3279" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_623_220">
                                                <rect width="13.9915" height="13.9915" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Web Links
                                    <a role="button" className="flex-label-add" onClick={() => {
                                        linkRef.current.show();
                                    }}>
                                        + Add
                                    </a>
                                </label>
                            </div>
                            {episode.links?.length ? (
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                {/*<ModulePosition position={positions[4]} index="4" setPositions={setPositions} />*/}
                                <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={episode.links ?? []}
                                    onOrderChange={(newList) => {
                                        setEpisode(h => {
                                            var newH = {...h};
                                            newH.links = newList;
                                            return newH;
                                        });
                                    }}
                                    itemClass="card-item-4"
                                    renderItem={(h, i) => (
                                        <>
                                            <LinkCard link={h} onRemove={!readOnly && ((v) => {
                                                var index = episode.links.findIndex(h => h.url == v.url && h.text == v.text);
                                                if (index < 0)
                                                    return;
                                                setEpisode(_e => {
                                                    let e = { ..._e };
                                                    e.links.splice(index, 1);
                                                    return e;
                                                });
                                            })} key={i} />
                                        </>
                                    )} endItem={
                                        <div className="card-item card-item-4">
                                            <button className="add-item add-item-4" style={{flexDirection: 'row', minHeight: 55.2}} onClick={() => {
                                                linkRef.current.show();
                                            }}>
                                                <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                <span>Add Link or Download</span>
                                            </button>
                                        </div>
                                    } />
                            </div>
                            ) : (
                                <div className="w-100">
                                    <div className="w-100">
                                        <button className="add-item full-width" onClick={() => {
                                            linkRef.current.show();
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                <g clip-path="url(#clip0_623_220)">
                                                    <path d="M5.24687 9.91182H4.08091C3.30783 9.91182 2.56642 9.60472 2.01977 9.05807C1.47312 8.51142 1.16602 7.77001 1.16602 6.99693C1.16602 6.22385 1.47312 5.48243 2.01977 4.93578C2.56642 4.38914 3.30783 4.08203 4.08091 4.08203H5.24687" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8.74414 4.08203H9.9101C10.6832 4.08203 11.4246 4.38914 11.9712 4.93578C12.5179 5.48243 12.825 6.22385 12.825 6.99693C12.825 7.77001 12.5179 8.51142 11.9712 9.05807C11.4246 9.60472 10.6832 9.91182 9.9101 9.91182H8.74414" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M4.66406 6.99609H9.3279" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_623_220">
                                                        <rect width="13.9915" height="13.9915" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <span>No links added yet</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                            
                            
                            <div style={{ marginBottom: '-16px' }} className="section-divider">
                                <label className="flex-label">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M10.4941 11.6579V5.82812" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M6.99609 11.6597V2.33203" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M3.49805 11.658V8.16016" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Polls
                                    <a role="button" className="flex-label-add" onClick={() => {
                                        pollRef.current.show();
                                    }}>
                                        + Add
                                    </a>
                                </label>
                            </div>
                            {episode.polls?.length ? (
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 card-container">
                                        {episode.polls?.length ? episode.polls.map((h, i) => {
                                            return (
                                                <div className="card-item-4">
                                                    <div></div>
                                                </div>
                                            );
                                        }) : null}
                                        {!readOnly && (
                                            <div className="card-item card-item-4">
                                                <button className="add-item add-item-4" style={{flexDirection: 'row', minHeight: 55.2}} onClick={() => {
                                                    pollRef.current.show();
                                                }}>
                                                    <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                                    <span>Add Poll</span>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="w-100">
                                    <div className="w-100">
                                        <button className="add-item full-width" onClick={() => {
                                            pollRef.current.show();
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 14" fill="none">
                                                <path d="M10.4941 11.6579V5.82812" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6.99609 11.6597V2.33203" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M3.49805 11.658V8.16016" stroke="currentColor" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <span>No polls added yet</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Expandable>

                    <Expandable title="Monitization" subTitle="Add merch, tickets, sponsor ads, and midroll">
                        <div className="w-100 sm-w-100 pt-10 pb-10 p-rel gap-10 f-wrap f-row">
                            <div style={{ marginBottom: '-5px' }} className="w-100">
                                <div className="flex f-start f-row gap-10">
                                    <label style={{ marginBottom: '0px' }} className="flex-label" htmlFor="show-merch">Podcast Merch</label>
                                    <label className="switch mb-0 ml-auto">
                                        <input type="checkbox" id="show-merch" readOnly={readOnly} onChange={e => {
                                            if (readOnly)
                                                return;
                                            setEpisode((ep) => {
                                                var nep = { ...ep };
                                                nep.toShow = nep.toShow || {};
                                                nep.toShow.merch = e.target.checked;
                                                return nep;
                                            });
                                        }} checked={episode.toShow?.merch} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="labelSubTitle">
                                    Merch is managed in the Merch & Products section
                                </div>
                            </div>
                            {!readOnly && (
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel">
                                    {/*<ModulePosition position={positions[6]} index="6" setPositions={setPositions} />*/}
                                    
                                    <div className="a-center f-center mt-10 mb-10">
                                        <a className="pm-link" target="_blank" href="/merch-list">
                                            Open Podcast Merch Manager
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M4.08008 4.08203H9.90987V9.91182" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M4.08008 9.91182L9.90987 4.08203" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            )}

                            <div style={{ marginBottom: '-5px' }} className="w-100">
                                <div className="flex f-start f-row gap-10">
                                    <label style={{ marginBottom: '0px' }} className="flex-label" htmlFor="show-events">Podcast Events</label>
                                    <label className="switch mb-0 ml-auto">
                                        <input type="checkbox" id="show-events" readOnly={readOnly} onChange={e => {
                                            if (readOnly)
                                                return;
                                            setEpisode((ep) => {
                                                var nep = { ...ep };
                                                nep.toShow = nep.toShow || {};
                                                nep.toShow.events = e.target.checked;
                                                return nep;
                                            });
                                        }} checked={episode.toShow?.events} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="labelSubTitle">
                                    Events are managed in the Events & Tickets section
                                </div>
                            </div>
                            {!readOnly && (
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel">
                                    {/*<ModulePosition position={positions[7]} index="7" setPositions={setPositions} />*/}
                                    
                                    <div className="a-center f-center mt-10 mb-10">
                                        <a className="pm-link" target="_blank" href="/event-list">
                                            Open Podcast Events Manager
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M4.08008 4.08203H9.90987V9.91182" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M4.08008 9.91182L9.90987 4.08203" stroke="#99A1AF" stroke-width="1.16596" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            )}

                            <div style={{ marginBottom: '-16px' }} className="w-100">
                                    <label style={{ marginBottom: '0px' }} className="flex-label" htmlFor="show-sponsors">
                                        Sponsors
                                        <a role="button" className="flex-label-add" onClick={() => {
                                            addSponsorRef.current.show();
                                        }}>
                                            + Add
                                        </a>
                                    </label>
                            </div>
                            
                            {episode.sponsors?.length ? (
                                <div className="w-100 sm-w-100 b-radius-4 b-1 p-10 p-rel sortable-item-wrapper">
                                    <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={episode.sponsors ?? []}
                                        onOrderChange={(newList) => {
                                            setEpisode(h => {
                                                var newH = {...h};
                                                newH.sponsors = newList;
                                                return newH;
                                            });
                                        }}
                                        itemClass="w-100"
                                        renderItem={(h, i) => (
                                            <>
                                                <SponsorCard sponsor={h} onRemove={!readOnly && ((_id) => {
                                                    var index = episode.sponsors.findIndex(h => h.id == _id);
                                                    if (index < 0)
                                                        return;
                                                    setEpisode(_e => {
                                                        let e = { ..._e };
                                                        e.sponsors.splice(index, 1);
                                                        return e;
                                                    });
                                                })} key={i} />
                                            </>
                                        )} />
                                </div>
                            ) : (
                                <>
                                    {!readOnly && (
                                        <div className="w-100">
                                            <div className="w-100">
                                                <button className="add-item full-width" onClick={() => {
                                                    addSponsorRef.current.show();
                                                }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M11.9961 2V21.9929" stroke="#99A1AF" stroke-width="1.99929" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M16.9942 5H9.49681C8.56888 5 7.67896 5.36862 7.02281 6.02476C6.36667 6.68091 5.99805 7.57083 5.99805 8.49876C5.99805 9.42669 6.36667 10.3166 7.02281 10.9728C7.67896 11.6289 8.56888 11.9975 9.49681 11.9975H14.495C15.423 11.9975 16.3129 12.3661 16.969 13.0223C17.6252 13.6784 17.9938 14.5684 17.9938 15.4963C17.9938 16.4242 17.6252 17.3141 16.969 17.9703C16.3129 18.6264 15.423 18.995 14.495 18.995H5.99805" stroke="#99A1AF" stroke-width="1.99929" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span>No sponsors added yet</span>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </Expandable>

                    {!isHosted && (<Expandable title="Publish Episode" subTitle="Multi-platform upload and publish timers">
                        <div className="w-100 sm-w-100 pt-10 pb-10 p-rel gap-10">
                            <div className="w-100 sm-w-100 p-rel f-row f-wrap gap-10">
                                <div className="w-100 f-row gap-5">
                                    <div className="flex f-row gap-10 a-center">
                                        <label className="mb-0">Multi-Directory Upload</label>
                                        <label className="switch mb-0">
                                            <input type="checkbox" id="mdu" readOnly={readOnly} checked={episode.multiDirectoryUpload} aria-label="Multi-Directory Upload"
                                                onChange={e => {
                                                    if (readOnly)
                                                        return;
                                                    setValue('multiDirectoryUpload', e.target.checked)
                                                }} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                    {episode.multiDirectoryUpload && (
                                        <>
                                            <label htmlFor="select-all" className="mb-0 ml-auto">Select All</label>
                                            <input readOnly={readOnly} type="checkbox" id="select-all" checked={getAllMdUpload()} onChange={() => toggleAllMdUpload()} />
                                        </>
                                    )}
                                </div>
                                {episode.multiDirectoryUpload && (
                                    <>
                                        <div className="flex f-row w-50 xs-w-100 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleMdUpload(0)}>
                                            <img width={50} height={50} src={audibleSvg} alt="Amazon Audible" />
                                            <label htmlFor="audible" className="ml-auto mb-0" style={{ pointerEvents: 'none', width: 'min-content' }}>Amazon Audible</label>
                                            <input readOnly={readOnly} type="checkbox" className="ml-auto" id="audible" style={{ pointerEvents: 'none' }} checked={mdUpload[0]} />
                                        </div>

                                        <div className="flex f-row w-50 xs-w-100 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleMdUpload(1)}>
                                            <img width={50} height={50} src={appleSvg} alt="Apple Podcast" />
                                            <label htmlFor="apple-podcast" className="ml-auto mb-0" style={{ pointerEvents: 'none', width: 'min-content' }}>Apple Podcast</label>
                                            <input readOnly={readOnly} type="checkbox" className="ml-auto" id="apple-podcast" style={{ pointerEvents: 'none' }} checked={mdUpload[1]} />
                                        </div>

                                        <div className="flex f-row w-50 xs-w-100 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleMdUpload(2)}>
                                            <img width={50} height={50} src={castboxSvg} alt="Castbox" />
                                            <label htmlFor="castbox" className="ml-auto mb-0" style={{ pointerEvents: 'none', width: 'min-content' }}>Castbox</label>
                                            <input readOnly={readOnly} type="checkbox" className="ml-auto" id="castbox" style={{ pointerEvents: 'none' }} checked={mdUpload[2]} />
                                        </div>

                                        <div className="flex f-row w-50 xs-w-100 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleMdUpload(3)}>
                                            <img width={50} height={50} src={iheartradioSvg} alt="iHeart" />
                                            <label htmlFor="iheart" className="ml-auto mb-0" style={{ pointerEvents: 'none', width: 'min-content' }}>iHeart</label>
                                            <input readOnly={readOnly} type="checkbox" className="ml-auto" id="iheart" style={{ pointerEvents: 'none' }} checked={mdUpload[3]} />
                                        </div>

                                        <div className="flex f-row w-50 xs-w-100 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleMdUpload(4)}>
                                            <img width={50} height={50} src={pandoraSvg} alt="Pandora" />
                                            <label htmlFor="pandora" className="ml-auto mb-0" style={{ pointerEvents: 'none', width: 'min-content' }}>Pandora</label>
                                            <input readOnly={readOnly} type="checkbox" className="ml-auto" id="pandora" style={{ pointerEvents: 'none' }} checked={mdUpload[4]} />
                                        </div>

                                        <div className="flex f-row w-50 xs-w-100 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleMdUpload(5)}>
                                            <img width={50} height={50} src={podbeanSvg} alt="Podbean" />
                                            <label htmlFor="podbean" className="ml-auto mb-0" style={{ pointerEvents: 'none', width: 'min-content' }}>Podbean</label>
                                            <input readOnly={readOnly} type="checkbox" className="ml-auto" id="podbean" style={{ pointerEvents: 'none' }} checked={mdUpload[5]} />
                                        </div>

                                        <div className="flex f-row w-50 xs-w-100 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleMdUpload(6)}>
                                            <img width={50} height={50} src={wonderySvg} alt="Wondery" />
                                            <label htmlFor="wondery" className="ml-auto mb-0" style={{ pointerEvents: 'none', width: 'min-content' }}>Wondery</label>
                                            <input readOnly={readOnly} type="checkbox" className="ml-auto" id="wondery" style={{ pointerEvents: 'none' }} checked={mdUpload[6]} />
                                        </div>

                                        <div className="flex f-row w-50 xs-w-100 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => toggleMdUpload(7)}>
                                            <img width={50} height={50} src={youtubemusicSvg} alt="YouTube Music" />
                                            <label htmlFor="yt-music" className="ml-auto mb-0" style={{ pointerEvents: 'none', width: 'min-content' }}>YouTube Music</label>
                                            <input readOnly={readOnly} type="checkbox" className="ml-auto" id="yt-music" style={{ pointerEvents: 'none' }} checked={mdUpload[7]} />
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="w-100 pt-10 p-rel">
                                <div className="flex f-row gap-10 a-center">
                                    <label className="mb-0">Ready To Publish?</label>
                                    <label className="switch mb-0">
                                        <input type="checkbox" readOnly={readOnly} checked={episode.readyToPublish} aria-label="Ready To Publish?"
                                            onChange={e => {
                                                if (readOnly)
                                                        return;
                                                    setValue('readyToPublish', e.target.checked)
                                            }} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            {episode.readyToPublish && (
                                <>
                                    <div className="w-100 pt-10 p-rel">
                                        <div className="flex f-col gap-10 a-start">
                                            <label className="mb-0">Publish Time*</label>
                                            <div className="a-center flex f-row gap-5">
                                                <input readOnly={readOnly} type="radio" id="publish-now" name="publish-time" checked={episode.airDate !== '' && new Date(episode.airDate) <= new Date()} onChange={e => {
                                                    if (readOnly)
                                                        return;
                                                    const now = formatDateTime(new Date());
                                                    setValue('airDate', now);
                                                }} style={{ transform: 'translateY(-2px)' }} />
                                                <label htmlFor="publish-now" className="mb-0 mr-10">Now</label>
                                                <input readOnly={readOnly} type="radio" id="publish-later" name="publish-time" checked={episode.airDate !== '' && new Date(episode.airDate) > new Date()} onChange={e => {
                                                    if (readOnly)
                                                        return;
                                                    var d = new Date();
                                                    d.setDate(d.getDate() + 1);
                                                    const scheduled = formatDateTime(d);
                                                    setValue('airDate', scheduled);
                                                }} style={{ transform: 'translateY(-2px)' }} />
                                                <label htmlFor="publish-later" className="mb-0">Schedule</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 sm-w-100 pt-10 p-rel f-row gap-20">
                                        <div className="w-50 gap-10 f-row f-wrap">
                                            <div className="w-30 sm-w-50 xs-w-100">
                                                <label htmlFor="airdate">Date</label>
                                                <input id="airdate" type="date" readOnly={readOnly || episode.airDate !== '' && new Date(episode.airDate) <= new Date()}
                                                    value={formatDate(new Date(episode.airDate || new Date()))}
                                                    onChange={(e) => {
                                                        var d = new Date(episode.airDate || new Date());
                                                        d.setFullYear(e.target.value.split('-')[0]);
                                                        d.setMonth(e.target.value.split('-')[1] - 1);
                                                        d.setDate(e.target.value.split('-')[2]);
                                                        setValue('airDate', formatDateTime(d));
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="w-50 gap-10 f-row f-wrap">
                                            <div className="w-30 sm-w-50 xs-w-100">
                                                <div className="flex f-row a-center f-between">
                                                    <label htmlFor="airdate">Time</label>
                                                    <span className="times-local">
                                                        All Times Are Local
                                                    </span>
                                                </div>
                                                <input id="airdate" type="time" readOnly={readOnly || episode.airDate !== '' && new Date(episode.airDate) <= new Date()}
                                                    value={formatTime(new Date(episode.airDate || new Date()))}
                                                    onChange={(e) => {
                                                        var d = new Date(episode.airDate || new Date());
                                                        d.setHours(e.target.value.split(':')[0]);
                                                        d.setMinutes(e.target.value.split(':')[1]);
                                                        setValue('airDate', formatDateTime(d));
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </Expandable>)}
                    
                    {!readOnly && (
                        <div className="content-box">
                            <div className="content-body">
                                <div className="w-100 a-center f-end f-row" style={{order: 10}}>
                                    {!!id && (
                                        <div className="pod-date-string">
                                            Last Saved: <span>{formatDateString(episode.updatedDate || episode.createdDate)}</span>
                                        </div>
                                    )}
                                    <div className="flex f-end f-row gap-5">
                                        <button onClick={save} className="btn">Update/Save Episode</button>
                                        {!isHosted && <button onClick={save} className="btn btn-green">Publish Episode</button>}
                                        {id && false && <button onClick={() => {
                                            setId(null);
                                            setFile(null);
                                            setArtFile(null);
                                            setEpFile(null);
                                            setFP('');
                                            setEpFP('');
                                            setArtFP('');
                                            setToAddImagesTitle('');
                                            setToAddVideoTitle('');
                                            setEpisode(defaultEpisode);
                                            setLoading(true);
                                        }} className="btn">New</button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </main>
    );
}

export default Episode;